import React, { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import ManagerNavbar from "../Layout/ManagerNavbar";
import API_BASE_URL from "../config";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&family=DM+Sans:wght@400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/icon?family=Material+Icons+Round');

:root{
  --bg:#F2F4F7;--surface:#FFFFFF;--surface2:#F7F8FC;--surface3:#EEF0F8;
  --border:#E2E4EF;--border2:#C8CCDD;--text:#171829;--text2:#555872;--text3:#9295AD;
  --accent:#1D4ED8;--accent-light:#EFF3FF;--accent-mid:#C7D4FD;
  --green:#15803D;--green-bg:#F0FDF4;--green-bd:#A7F3D0;
  --amber:#B45309;--amber-bg:#FFFBEB;--amber-bd:#FCD34D;
  --red:#B91C1C;--red-bg:#FFF1F2;--red-bd:#FECDD3;
  --violet:#6D28D9;--violet-bg:#F5F3FF;--violet-bd:#DDD6FE;
  --teal:#0F766E;--teal-bg:#F0FDFA;--teal-bd:#5EEAD4;
  --orange:#C2410C;--orange-bg:#FFF7ED;--orange-bd:#FDBA74;
  --sidebar:#FFFFFF;--sidebar2:#F7F8FC;--radius:14px;--shadow:0 1px 4px rgba(0,0,0,.07),0 4px 20px rgba(0,0,0,.04);
}
.me-root *{box-sizing:border-box;margin:0;padding:0}
.me-root{
  font-family:'Outfit',sans-serif;background:var(--bg);color:var(--text);display:flex;height:calc(100vh - 106px);overflow:hidden;
}
.me-mi{font-family:'Material Icons Round';font-style:normal;font-weight:400;font-size:20px;line-height:1;display:inline-block;-webkit-font-smoothing:antialiased}
.me-sidebar{width:252px;min-width:252px;background:var(--sidebar);border-right:1px solid var(--border);display:flex;flex-direction:column;overflow:hidden}
.me-brand{height:58px;padding:0 20px;border-bottom:1px solid var(--border);display:flex;align-items:center;flex-shrink:0;background:var(--sidebar)}
.me-brand-logo{display:flex;align-items:center;gap:10px}
.me-brand-icon{width:34px;height:34px;background:linear-gradient(135deg,#3B82F6,#8B5CF6);border-radius:9px;display:flex;align-items:center;justify-content:center}
.me-brand-name{font-size:17px;font-weight:700;color:var(--text)}
.me-brand-tag{font-size:10px;color:var(--text3);letter-spacing:1.2px;text-transform:uppercase;margin-top:3px}
.me-chip{margin:12px 10px;background:linear-gradient(135deg,#F8FAFF,#F2F5FF);border:1px solid #D7DDFB;border-radius:11px;padding:11px 13px;display:flex;align-items:center;gap:10px}
.me-chip-av,.me-top-av{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,#F59E0B,#EF4444);display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#fff;flex-shrink:0}
.me-chip-name{font-size:13px;font-weight:600;color:var(--text)}
.me-chip-role{font-size:10px;color:var(--text3);margin-top:1px}
.me-chip-badge{margin-left:auto;background:#F59E0B;color:#78350F;font-size:9px;font-weight:700;padding:2px 7px;border-radius:10px;letter-spacing:.4px}
.me-sidebar-scroll{overflow-y:auto;flex:1}
.me-sidebar-scroll::-webkit-scrollbar{width:3px}
.me-sidebar-scroll::-webkit-scrollbar-thumb{background:#D7DBEB;border-radius:3px}
.me-nav-section{padding:14px 12px 4px;font-size:9.5px;letter-spacing:1.8px;text-transform:uppercase;color:#A0A6C0;font-weight:600}
.me-nav-item{display:flex;align-items:center;gap:10px;padding:9px 14px;font-size:13px;color:var(--text2);cursor:pointer;border-radius:9px;margin:1px 8px;transition:all .15s;user-select:none}
.me-nav-item:hover{background:#F4F6FD;color:var(--text)}
.me-nav-item.active{background:#EEF2FF;color:var(--accent);font-weight:600}
.me-nav-badge{margin-left:auto;min-width:20px;height:20px;background:#EF4444;border-radius:10px;font-size:10px;color:#fff;display:flex;align-items:center;justify-content:center;padding:0 5px;font-weight:700}
.me-nav-badge.me-amber{background:#F59E0B;color:#78350F}
.me-sidebar-foot{margin-top:auto;border-top:1px solid var(--border);padding:12px;background:var(--sidebar)}
.me-nav-item.dim{color:var(--text3)}
.me-main{flex:1;display:flex;flex-direction:column;overflow:hidden;min-width:0}
.me-topbar{height:58px;background:var(--surface);border-bottom:1px solid var(--border);display:flex;align-items:center;padding:0 28px;gap:12px;flex-shrink:0}
.me-breadcrumb{display:flex;align-items:center;gap:6px;font-size:13px;color:var(--text3)}
.me-breadcrumb .active{color:var(--text);font-weight:600}
.me-breadcrumb .sep{color:var(--border2)}
.me-topbar-right{margin-left:auto;display:flex;align-items:center;gap:10px;position:relative}
.me-icon-btn{width:34px;height:34px;border-radius:8px;border:1px solid var(--border);background:var(--surface);display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--text2);transition:all .15s;position:relative}
.me-icon-btn:hover{background:var(--surface2)}
.me-notif-dot{position:absolute;top:6px;right:6px;width:7px;height:7px;background:#EF4444;border-radius:50%;border:1.5px solid #fff}
.me-content{flex:1;overflow-y:auto;padding:22px 26px;display:flex;flex-direction:column;gap:18px}
.me-content::-webkit-scrollbar{width:5px}
.me-content::-webkit-scrollbar-thumb{background:#C8CCDD;border-radius:4px}
.me-page{display:flex;flex-direction:column;gap:18px}
.me-urgent{background:linear-gradient(90deg,#7C2D12,#B91C1C,#DC2626);border-radius:10px;padding:12px 18px;display:flex;align-items:center;gap:12px;color:#fff}
.me-urgent-copy{font-size:13px;font-weight:500}
.me-urgent-sub{font-size:11.5px;color:rgba(255,255,255,.7);margin-top:1px;font-family:'DM Sans',sans-serif}
.me-btn{padding:8px 15px;border-radius:8px;border:1px solid var(--border);background:var(--surface);font-size:13px;color:var(--text);cursor:pointer;font-family:'Outfit',sans-serif;display:inline-flex;align-items:center;gap:6px;font-weight:500;transition:all .15s}
.me-btn:hover{background:var(--surface2);border-color:var(--border2)}
.me-btn-primary{background:var(--accent);color:#fff;border-color:var(--accent)}
.me-btn-primary:hover{background:#1E40AF}
.me-btn-success{background:var(--green-bg);color:var(--green);border-color:var(--green-bd)}
.me-btn-danger{background:var(--red-bg);color:var(--red);border-color:var(--red-bd)}
.me-btn-amber{background:var(--amber-bg);color:var(--amber);border-color:var(--amber-bd)}
.me-btn-sm{padding:5px 11px;font-size:12px;border-radius:7px}
.me-btn-ghost{border:none;background:transparent;color:var(--text2);padding:0}
.me-btn-full{width:100%;justify-content:center}
.me-kpi-row{display:grid;grid-template-columns:repeat(5,1fr);gap:12px}
.me-kpi{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:15px 16px;box-shadow:var(--shadow);transition:all .18s}
.me-kpi:hover{transform:translateY(-2px);box-shadow:0 6px 24px rgba(0,0,0,.09);border-color:var(--border2)}
.me-kpi-top{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:8px}
.me-kpi-label{font-size:11.5px;color:var(--text2);font-weight:500;font-family:'DM Sans',sans-serif;line-height:1.3}
.me-kpi-icon{width:34px;height:34px;border-radius:9px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.me-ki-blue{background:var(--accent-light);color:var(--accent)}
.me-ki-green{background:var(--green-bg);color:var(--green)}
.me-ki-amber{background:var(--amber-bg);color:var(--amber)}
.me-ki-violet{background:var(--violet-bg);color:var(--violet)}
.me-ki-teal{background:var(--teal-bg);color:var(--teal)}
.me-ki-red{background:var(--red-bg);color:var(--red)}
.me-ki-orange{background:var(--orange-bg);color:var(--orange)}
.me-kpi-val{font-size:22px;font-weight:700;color:var(--text)}
.me-kpi-trend{font-size:11px;color:var(--text3);margin-top:3px;font-family:'DM Sans',sans-serif}
.me-two-col{display:grid;grid-template-columns:1.55fr 1fr;gap:16px}
.me-two-col-equal{display:grid;grid-template-columns:1fr 1fr;gap:16px}
.me-three-col{display:grid;grid-template-columns:1fr 1fr 1fr;gap:14px}
.me-card{background:var(--surface);border:1px solid var(--border);border-radius:var(--radius);padding:18px;box-shadow:var(--shadow)}
.me-card-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;gap:10px}
.me-card-title{font-size:14px;font-weight:600;color:var(--text)}
.me-card-sub{font-size:12px;color:var(--text3);margin-top:2px;font-family:'DM Sans',sans-serif}
.me-stat-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}
.me-mini-stats{display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:1px solid var(--border);border-radius:10px;overflow:hidden}
.me-mini-stat{padding:13px 16px;text-align:center;border-right:1px solid var(--border)}
.me-mini-stat:last-child{border-right:none}
.me-ms-val{font-size:18px;font-weight:700}
.me-ms-lbl{font-size:11px;color:var(--text3);margin-top:2px;font-family:'DM Sans',sans-serif}
.me-approval-item{display:flex;align-items:flex-start;gap:14px;padding:13px 0;border-bottom:1px solid var(--border)}
.me-approval-item:last-child{border-bottom:none;padding-bottom:0}
.me-av{width:38px;height:38px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#fff;flex-shrink:0}
.me-av-blue{background:linear-gradient(135deg,#3B82F6,#6366F1)} .me-av-green{background:linear-gradient(135deg,#10B981,#059669)} .me-av-orange{background:linear-gradient(135deg,#F59E0B,#EF4444)} .me-av-violet{background:linear-gradient(135deg,#8B5CF6,#EC4899)} .me-av-teal{background:linear-gradient(135deg,#06B6D4,#0891B2)}
.me-appr-body{flex:1;min-width:0}
.me-appr-name{font-size:13px;font-weight:600}
.me-appr-detail{font-size:12px;color:var(--text3);margin-top:2px;font-family:'DM Sans',sans-serif}
.me-appr-meta{display:flex;align-items:center;gap:8px;margin-top:5px;flex-wrap:wrap}
.me-appr-right{display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0}
.me-appr-amt{font-size:15px;font-weight:700}
.me-appr-time{font-size:11px;color:var(--text3);font-family:'DM Sans',sans-serif}
.me-appr-actions{display:flex;gap:6px;flex-wrap:wrap;justify-content:flex-end}
.me-pill{display:inline-flex;align-items:center;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;gap:4px;white-space:nowrap}
.me-pill::before{content:'';width:5px;height:5px;border-radius:50%;flex-shrink:0}
.me-p-draft{background:#F1F5F9;color:#475569}.me-p-draft::before{background:#94A3B8}
.me-p-submitted{background:var(--violet-bg);color:var(--violet)}.me-p-submitted::before{background:var(--violet)}
.me-p-pending{background:var(--amber-bg);color:var(--amber)}.me-p-pending::before{background:var(--amber)}
.me-p-approved{background:var(--green-bg);color:var(--green)}.me-p-approved::before{background:var(--green)}
.me-p-rejected{background:var(--red-bg);color:var(--red)}.me-p-rejected::before{background:var(--red)}
.me-p-reimbursed{background:var(--accent-light);color:var(--accent)}.me-p-reimbursed::before{background:var(--accent)}
.me-p-info{background:var(--orange-bg);color:var(--orange)}.me-p-info::before{background:var(--orange)}
.me-p-l1{background:#FEF9C3;color:#854D0E}.me-p-l1::before{background:#CA8A04}
.me-p-l2{background:#DBEAFE;color:#1E40AF}.me-p-l2::before{background:#3B82F6}
.me-cat{background:var(--surface3);color:var(--text2);border-radius:5px;padding:2px 8px;font-size:11px;font-family:'DM Sans',sans-serif}
.me-alert{border-radius:9px;padding:11px 14px;display:flex;align-items:center;gap:10px;font-size:13px;font-family:'DM Sans',sans-serif}
.me-as-amber{background:var(--amber-bg);color:var(--amber);border:1px solid var(--amber-bd)}
.me-as-red{background:var(--red-bg);color:var(--red);border:1px solid var(--red-bd)}
.me-as-blue{background:var(--accent-light);color:var(--accent);border:1px solid var(--accent-mid)}
.me-as-green{background:var(--green-bg);color:var(--green);border:1px solid var(--green-bd)}
.me-tabs{display:flex;gap:0;border-bottom:1px solid var(--border);margin-bottom:14px}
.me-tab{padding:11px 14px;border:none;background:transparent;color:var(--text3);font-size:12.5px;font-weight:600;cursor:pointer;border-bottom:2px solid transparent}
.me-tab.active{color:var(--accent);border-bottom-color:var(--accent)}
.me-table-wrap{overflow-x:auto;border-radius:10px;border:1px solid var(--border)}
.me-table-scroll{overflow-y:auto;max-height:calc(100vh - 360px)}
.me-table-scroll::-webkit-scrollbar{width:5px;height:5px}
.me-table-scroll::-webkit-scrollbar-thumb{background:#C8CCDD;border-radius:4px}
.me-table-scroll::-webkit-scrollbar-track{background:transparent}
.me-table{width:100%;border-collapse:collapse;font-family:'DM Sans',sans-serif;min-width:600px;}
.me-pagination{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;border-top:1px solid var(--border);}
.me-pagination-info{font-size:12px;color:var(--text3);font-family:'DM Sans',sans-serif;}
.me-pagination-btns{display:flex;align-items:center;gap:8px;}
.me-pagination-page{font-size:12px;color:var(--text2);font-family:'DM Sans',sans-serif;min-width:80px;text-align:center;}
.me-table th{background:var(--surface2);padding:10px 13px;text-align:left;font-size:11px;font-weight:700;color:var(--text2);text-transform:uppercase;letter-spacing:.6px;border-bottom:1px solid var(--border);position:sticky;top:0;z-index:1}
.me-table td{padding:11px 13px;border-bottom:1px solid var(--border);font-size:13px;color:var(--text);vertical-align:middle}
.me-table tr:last-child td{border-bottom:none}
.me-table tbody tr:hover td{background:var(--surface2)}
.me-link{color:var(--accent);font-weight:700;cursor:pointer}
.me-bar-chart{display:flex;flex-direction:column;gap:10px}
.me-bar-row{display:flex;align-items:center;gap:10px}
.me-bar-label{font-size:12px;color:var(--text2);width:110px;flex-shrink:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-family:'DM Sans',sans-serif}
.me-bar-track,.me-prog-wrap{flex:1;background:#EEF0F8;border-radius:4px;height:9px;overflow:hidden}
.me-prog-wrap{height:7px;margin-top:5px}
.me-bar-fill,.me-prog-fill{height:100%;border-radius:4px}
.me-bar-val{font-size:12px;font-weight:600;color:var(--text);width:55px;text-align:right;flex-shrink:0;font-family:'DM Sans',sans-serif}
.me-member-row,.me-overdue-item,.me-policy-item,.me-budget-row{display:flex;align-items:center;gap:11px;padding:10px 0;border-bottom:1px solid var(--border)}
.me-member-row:last-child,.me-overdue-item:last-child,.me-policy-item:last-child,.me-budget-row:last-child{border-bottom:none}
.me-mem-info,.me-ov-info{flex:1;min-width:0}
.me-mem-name,.me-ov-name{font-size:13px;font-weight:600}
.me-mem-role,.me-ov-detail{font-size:11px;color:var(--text3);margin-top:1px;font-family:'DM Sans',sans-serif}
.me-mem-right,.me-ov-right{text-align:right}
.me-mem-amt{font-size:13px;font-weight:700}
.me-donut-wrap{display:flex;align-items:center;gap:18px;margin:4px 0}
.me-donut{width:82px;height:82px;border-radius:50%;flex-shrink:0;background:conic-gradient(var(--accent) 0deg 126deg,var(--green) 126deg 219deg,var(--amber) 219deg 279deg,var(--violet) 279deg 330deg,var(--red) 330deg 360deg);position:relative}
.me-donut::after{content:'';position:absolute;inset:15px;background:var(--surface);border-radius:50%}
.me-legend{display:flex;flex-direction:column;gap:5px}
.me-leg-item{display:flex;align-items:center;gap:8px;font-size:11.5px;font-family:'DM Sans',sans-serif}
.me-leg-dot{width:8px;height:8px;border-radius:2px;flex-shrink:0}
.me-leg-lbl{color:var(--text2);min-width:70px}
.me-leg-val{margin-left:auto;color:var(--text);font-weight:600;font-size:12px}
.me-report-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px}
.me-report-card{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:16px;box-shadow:var(--shadow);cursor:pointer;transition:all .18s}
.me-report-card:hover{transform:translateY(-2px);border-color:var(--border2)}
.me-rc-icon{width:42px;height:42px;border-radius:12px;display:flex;align-items:center;justify-content:center;margin-bottom:12px}
.me-rc-title{font-size:13px;font-weight:700}
.me-rc-desc{font-size:11.5px;color:var(--text3);margin-top:6px;font-family:'DM Sans',sans-serif;line-height:1.45}
.me-rc-footer{display:flex;align-items:center;justify-content:space-between;gap:6px;margin-top:12px}
.me-rc-tag{background:var(--surface3);padding:4px 8px;border-radius:999px;font-size:10px;font-weight:700;color:var(--text2)}
.me-timeline{display:flex;flex-direction:column;gap:0}
.me-tl-item{display:flex;gap:12px;padding-bottom:16px;position:relative}
.me-tl-item:not(:last-child)::before{content:'';position:absolute;left:15px;top:28px;bottom:0;width:1px;background:var(--border)}
.me-tl-dot{width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;z-index:1}
.me-tl-title{font-size:13px;font-weight:600}
.me-tl-desc,.me-tl-time{font-size:12px;color:var(--text3);margin-top:1px;font-family:'DM Sans',sans-serif}
.me-filter-row,.me-form-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}
.me-form-grid{grid-template-columns:1fr 1fr}
.me-form-row{display:flex;gap:12px}
.me-form-row .me-field{flex:1}
.me-field{display:flex;flex-direction:column;gap:5px}
.me-label{font-size:12px;font-weight:600;color:var(--text2)}
.me-input,.me-select,.me-textarea{padding:9px 12px;border-radius:8px;border:1px solid var(--border);background:var(--surface);font-size:13px;color:var(--text);font-family:'Outfit',sans-serif;outline:none;width:100%}
.me-input:focus,.me-select:focus,.me-textarea:focus{border-color:var(--accent)}
.me-textarea{min-height:90px;resize:vertical}
.me-claim-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px}
.me-claim-card{background:var(--surface);border:1px solid var(--border);border-radius:14px;padding:16px;box-shadow:var(--shadow)}
.me-claim-title{font-size:14px;font-weight:700}
.me-claim-meta{font-size:12px;color:var(--text3);margin-top:4px;font-family:'DM Sans',sans-serif}
.me-claim-amount{font-size:22px;font-weight:700;margin:14px 0 8px}
.me-budget-dept{font-size:13px;font-weight:600;color:var(--text);width:130px;flex-shrink:0}
.me-budget-track{flex:1}
.me-budget-labels{display:flex;justify-content:space-between;margin-bottom:4px}
.me-budget-spent{font-size:12px;font-weight:600}
.me-budget-total{font-size:11px;color:var(--text3);font-family:'DM Sans',sans-serif}
.me-budget-pct{font-size:13px;font-weight:700;width:40px;text-align:right;flex-shrink:0}
.me-notif-panel{position:absolute;top:44px;right:0;width:340px;background:var(--surface);border:1px solid var(--border);border-radius:14px;box-shadow:0 12px 36px rgba(8,2,53,.13),0 2px 8px rgba(8,2,53,.07);overflow:hidden;z-index:50}
.me-notif-head{padding:14px 16px;border-bottom:1px solid var(--border);display:flex;align-items:center;justify-content:space-between}
.me-notif-list{max-height:320px;overflow-y:auto}
.me-notif-item{display:flex;gap:10px;padding:12px 16px;border-bottom:1px solid var(--border);cursor:pointer}
.me-notif-item:hover{background:var(--surface2)}
.me-notif-item:last-child{border-bottom:none}
.me-notif-icon{width:34px;height:34px;border-radius:10px;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.me-notif-text{font-size:12.5px;line-height:1.4}
.me-notif-time{font-size:11px;color:var(--text3);margin-top:2px;font-family:'DM Sans',sans-serif}
.me-modal-overlay{position:fixed;inset:0;background:rgba(13,15,30,.55);display:flex;align-items:center;justify-content:center;z-index:9000;padding:20px}
.me-modal{background:var(--surface);border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,.18);width:min(680px,100%);max-height:88vh;display:flex;flex-direction:column;overflow:hidden}
.me-modal-head{display:flex;align-items:center;justify-content:space-between;padding:20px 24px 16px;border-bottom:1px solid var(--border);flex-shrink:0}
.me-modal-title{font-size:16px;font-weight:700}
.me-close{width:30px;height:30px;border-radius:6px;border:none;background:var(--surface2);cursor:pointer;color:var(--text3)}
.me-modal-body{padding:20px 24px;overflow-y:auto;flex:1}
.me-modal-body::-webkit-scrollbar{width:4px}
.me-modal-body::-webkit-scrollbar-thumb{background:var(--border2);border-radius:4px}
.me-modal-foot{padding:14px 24px;display:flex;justify-content:flex-end;gap:8px;flex-wrap:wrap;border-top:1px solid var(--border);flex-shrink:0;background:var(--surface2)}
.me-detail-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px 16px;margin:14px 0}
.me-detail-row{padding:10px 12px;border:1px solid var(--border);border-radius:10px;background:var(--surface2)}
.me-detail-full{grid-column:1/-1}
.me-td-green{background:var(--green-bg);color:var(--green);border:1.5px solid var(--green-bd)}
.me-td-amber{background:var(--amber-bg);color:var(--amber);border:1.5px solid var(--amber-bd)}
.me-td-blue{background:var(--accent-light);color:var(--accent);border:1.5px solid var(--accent-mid)}
.me-td-violet{background:var(--violet-bg);color:var(--violet);border:1.5px solid var(--violet-bd)}
.me-td-red{background:var(--red-bg);color:var(--red);border:1.5px solid var(--red-bd)}
.me-td-grey{background:#F1F5F9;color:#94A3B8;border:1.5px solid #E2E8F0}
.me-tl-dot .me-mi{font-size:15px}
.me-detail-key{font-size:11px;color:var(--text3);font-family:'DM Sans',sans-serif;text-transform:uppercase;letter-spacing:.4px}
.me-detail-val{font-size:13px;font-weight:600;margin-top:4px}
.me-empty{padding:32px 20px;text-align:center;color:var(--text3);font-family:'DM Sans',sans-serif}
.me-switch{width:40px;height:22px;background:var(--accent);border-radius:11px;cursor:pointer;position:relative;transition:background .2s;flex-shrink:0}
.me-switch-dot{width:18px;height:18px;background:#fff;border-radius:50%;position:absolute;right:2px;top:2px;transition:all .2s}
.me-switch.off{background:#94A3B8}
.me-switch.off .me-switch-dot{right:20px}
@media (max-width:1200px){.me-kpi-row,.me-report-grid,.me-claim-grid,.me-stat-grid{grid-template-columns:repeat(2,1fr)}.me-two-col,.me-two-col-equal,.me-three-col{grid-template-columns:1fr}.me-filter-row{grid-template-columns:1fr 1fr}}
@media (max-width:900px){.me-root{flex-direction:column;height:auto;min-height:calc(100vh - 106px)}.me-sidebar{width:100%;min-width:0;max-height:320px}.me-kpi-row,.me-report-grid,.me-claim-grid,.me-form-grid,.me-filter-row,.me-stat-grid{grid-template-columns:1fr}.me-topbar{padding:0 16px}.me-content{padding:16px}}
.me-spinner-wrap{display:flex;align-items:center;justify-content:center;flex:1;min-height:320px;flex-direction:column;gap:14px}
.me-spinner{width:40px;height:40px;border:3px solid var(--border2);border-top-color:var(--accent);border-radius:50%;animation:me-spin .65s linear infinite}
@keyframes me-spin{to{transform:rotate(360deg)}}
.me-spinner-label{font-size:13px;color:var(--text3);font-family:'DM Sans',sans-serif}
`;

const NAV_ITEMS = [
  { key: "dashboard", icon: "dashboard", label: "Team Dashboard" },
  { key: "my-expenses", icon: "receipt_long", label: "My Expenses" },
  // { key: "submit-expense", icon: "add_circle_outline", label: "Submit Expense" },
  { key: "my-claims", icon: "folder_open", label: "My Claims" },
  { key: "team-expenses", icon: "group", label: "Team Expenses" },
  { key: "approval-queue", icon: "fact_check", label: "Approval Queue" },
  { key: "analytics", icon: "bar_chart", label: "Team Analytics" },
  { key: "reports", icon: "summarize", label: "Expense Reports" },
  { key: "budget", icon: "pie_chart", label: "Budget vs Actual" },
];





const NOTIFICATIONS = [
  { id: 1, icon: "fact_check", tone: "amber", text: "Priya Kulkarni submitted EXP-2026-00021 for approval.", time: "4 days ago", page: "approval-queue" },
  { id: 2, icon: "schedule", tone: "red", text: "Reminder: 5 expenses are pending your approval.", time: "Today, 9:00 AM", page: "approval-queue" },
  { id: 3, icon: "pie_chart", tone: "blue", text: "Backend Team budget is at 75% utilization for May 2026.", time: "Today, 8:00 AM", page: "budget" },
];

const PAGE_LABELS = {
  dashboard: "Manager Dashboard",
  "my-expenses": "My Expenses",
  "submit-expense": "Submit Expense",
  "my-claims": "My Claims",
  "team-expenses": "Team Expenses",
  "approval-queue": "Approval Queue",
  analytics: "Team Analytics",
  reports: "Expense Reports",
  budget: "Budget vs Actual",
  settings: "Settings",
};

const fmtCurrency = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
const YEAR_OPTIONS = Array.from({ length: new Date().getFullYear() - 2023 }, (_, i) => new Date().getFullYear() - i);
const PAGE_SIZE = 20;
const initialOf = (name) => (name || "M").split(" ").map((part) => part[0]).join("").slice(0, 2).toUpperCase();

const statusClass = (status) => ({
  Draft: "me-p-draft",
  Submitted: "me-p-submitted",
  "Pending L1": "me-p-l1",
  "Pending L2": "me-p-l2",
  Approved: "me-p-approved",
  Rejected: "me-p-rejected",
  Reimbursed: "me-p-reimbursed",
  "Info Requested": "me-p-info",
}[status] || "me-p-pending");

const toneClass = (tone) => ({
  blue: "me-ki-blue",
  green: "me-ki-green",
  amber: "me-ki-amber",
  violet: "me-ki-violet",
  teal: "me-ki-teal",
  red: "me-ki-red",
  orange: "me-ki-orange",
}[tone] || "me-ki-blue");

const barClass = (tone) => ({
  blue: { background: "var(--accent)" },
  green: { background: "var(--green)" },
  amber: { background: "var(--amber)" },
  red: { background: "var(--red)" },
  violet: { background: "var(--violet)" },
  teal: { background: "var(--teal)" },
}[tone] || { background: "var(--accent)" });

function Mi({ icon }) {
  return <span className="me-mi">{icon}</span>;
}

function Pill({ status }) {
  return <span className={`me-pill ${statusClass(status)}`}>{status}</span>;
}

function Modal({ title, children, footer, onClose }) {
  return (
    <div className="me-modal-overlay" onClick={onClose}>
      <div className="me-modal" onClick={(e) => e.stopPropagation()}>
        <div className="me-modal-head">
          <div className="me-modal-title">{title}</div>
          <button className="me-close" onClick={onClose}>✕</button>
        </div>
        <div className="me-modal-body">{children}</div>
        {footer ? <div className="me-modal-foot">{footer}</div> : null}
      </div>
    </div>
  );
}

function Sidebar({ activePage, onNav, queueCount, onModal }) {
  return (
    <div className="me-sidebar">
      <div className="me-brand">
        <div className="me-brand-logo">
          <div className="me-brand-icon"><Mi icon="account_balance_wallet" /></div>
          <div>
            <div className="me-brand-name">Balsuite</div>
            <div className="me-brand-tag">Manager Expenses</div>
          </div>
        </div>
      </div>
      {/* <div className="me-chip">
        <div className="me-chip-av">RS</div>
        <div>
          <div className="me-chip-name">Ravi Sharma</div>
          <div className="me-chip-role">Engineering Manager</div>
        </div>
        <div className="me-chip-badge">L1</div>
      </div> */}
      <div className="me-sidebar-scroll">
        <div className="me-nav-section">Workspace</div>
        {NAV_ITEMS.slice(1, 3).map((item) => (
          <div key={item.key}
            className={`me-nav-item ${activePage === item.key ? "active" : ""}`}
            onClick={() => item.key === "submit-expense" ? onModal("submit-expense", null) : onNav(item.key)}
          >
            <Mi icon={item.icon} />
            {item.label}
          </div>
        ))}
        <div className="me-nav-section">Team Control</div>
        {NAV_ITEMS.filter((item) => ["dashboard", "team-expenses", "approval-queue", "analytics"].includes(item.key)).map((item) => (
          <div key={item.key} className={`me-nav-item ${activePage === item.key ? "active" : ""}`} onClick={() => onNav(item.key)}>
            <Mi icon={item.icon} />
            {item.label}
            {item.key === "approval-queue" ? <span className="me-nav-badge">{queueCount}</span> : null}
          </div>
        ))}
        <div className="me-nav-section">Insights</div>
        {NAV_ITEMS.filter((item) => ["reports", "budget"].includes(item.key)).map((item) => (
          <div key={item.key} className={`me-nav-item ${activePage === item.key ? "active" : ""}`} onClick={() => onNav(item.key)}>
            <Mi icon={item.icon} />
            {item.label}
          </div>
        ))}
      </div>
      <div className="me-sidebar-foot">
        <div className="me-nav-item dim" onClick={() => onNav("settings")}><Mi icon="settings" />Settings</div>
      </div>
    </div>
  );
}

function Topbar({ activePage, notifOpen, setNotifOpen, onNav, onModal }) {
  return (
    <div className="me-topbar">
      <div className="me-breadcrumb">
        <Mi icon="home" />
        <span>›</span>
        <span className="active">{PAGE_LABELS[activePage]}</span>
      </div>
      <div className="me-topbar-right">
        {/* <button className="me-btn me-btn-sm" onClick={() => toast.success("Export prepared successfully.")}><Mi icon="file_download" />Export</button>
        <button className="me-icon-btn" onClick={() => toast.info("Global search is ready for integration.")}><Mi icon="search" /></button> */}
        {/* <button className="me-icon-btn" onClick={() => setNotifOpen((v) => !v)}>
          <Mi icon="notifications" />
          <span className="me-notif-dot" />
        </button> */}
        {/* {notifOpen ? (
          <div className="me-notif-panel">
            <div className="me-notif-head">
              <strong>Notifications</strong>
              <button className="me-btn me-btn-ghost" onClick={() => toast.success("All notifications marked as read.")}>Mark all read</button>
            </div>
            <div className="me-notif-list">
              {NOTIFICATIONS.map((note) => (
                <div key={note.id} className="me-notif-item" onClick={() => { onNav(note.page); setNotifOpen(false); }}>
                  <div className={`me-notif-icon ${toneClass(note.tone)}`}><Mi icon={note.icon} /></div>
                  <div>
                    <div className="me-notif-text">{note.text}</div>
                    <div className="me-notif-time">{note.time}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null} */}
      </div>
    </div>
  );
}

function DashboardPage({ teamDashboard, teamQueue, myStats, onNav, onModal, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const queue = teamQueue || [];
  const highValue = queue.filter(e => Number(e.amount) >= 10000).length;
  const memberRows = (teamDashboard?.memberRows || []).slice(0, 5);
  const maxMember = Number(memberRows[0]?.total || 1);
  const catRows = (teamDashboard?.catRows || []).slice(0, 5);
  const CAT_COLORS = ["var(--accent)", "var(--green)", "var(--amber)", "var(--violet)", "var(--red)"];
  const recentHistory = teamDashboard?.recentHistory || [];

  return (
    <div className="me-page">
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: -6 }}>
        <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      {queue.length > 0 && (
        <div className="me-urgent">
          <Mi icon="priority_high" />
          <div>
            <div className="me-urgent-copy">{queue.length} expense{queue.length !== 1 ? "s" : ""} require your approval</div>
            <div className="me-urgent-sub">{highValue} high-value request{highValue !== 1 ? "s" : ""} above ₹10,000</div>
          </div>
          <button className="me-btn" style={{ marginLeft: "auto", whiteSpace: "nowrap" }} onClick={() => onNav("approval-queue")}>Review Now</button>
        </div>
      )}

      <div className="me-kpi-row">
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Pending My Approval</div><div className="me-kpi-icon me-ki-red"><Mi icon="pending_actions" /></div></div><div className="me-kpi-val">{queue.length}</div><div className="me-kpi-trend">{highValue} high-value items</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Team Spend</div><div className="me-kpi-icon me-ki-blue"><Mi icon="groups" /></div></div><div className="me-kpi-val">{fmtCurrency(teamDashboard?.teamSpend || 0)}</div><div className="me-kpi-trend">{teamDashboard?.totalExpenses || 0} expenses filed</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Approved</div><div className="me-kpi-icon me-ki-green"><Mi icon="check_circle" /></div></div><div className="me-kpi-val">{teamDashboard?.approvedCount || 0}</div><div className="me-kpi-trend">{fmtCurrency(teamDashboard?.approvedTotal || 0)} total approved</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">My Total This Month</div><div className="me-kpi-icon me-ki-amber"><Mi icon="receipt" /></div></div><div className="me-kpi-val">{fmtCurrency(myStats?.totalThisMonth || 0)}</div><div className="me-kpi-trend">{myStats?.pendingApproval || 0} pending approval</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Reimbursed YTD</div><div className="me-kpi-icon me-ki-violet"><Mi icon="payments" /></div></div><div className="me-kpi-val">{fmtCurrency(myStats?.reimbursedYTD || 0)}</div><div className="me-kpi-trend">Year to date</div></div>
      </div>

      <div className="me-two-col">
        <div className="me-card">
          <div className="me-card-head">
            <div>
              <div className="me-card-title">Approval Queue Snapshot</div>
              <div className="me-card-sub">Immediate manager actions</div>
            </div>
          </div>
          {queue.length === 0
            ? <div className="me-empty">All caught up. No pending items.</div>
            : queue.slice(0, 5).map((item, idx) => {
              const avColors = ["me-av-blue","me-av-green","me-av-orange","me-av-violet","me-av-teal"];
              return (
                <div key={item.id} className="me-approval-item">
                  <div className={`me-av ${avColors[idx % 5]}`}>{initialOf(item.employee)}</div>
                  <div className="me-appr-body">
                    <div className="me-appr-name">{item.employee}</div>
                    <div className="me-appr-detail"><span className="me-link" onClick={() => onModal("details", item)}>{item.id}</span> · {item.title}</div>
                  </div>
                  <div className="me-appr-right">
                    <div className="me-appr-amt">{fmtCurrency(item.amount)}</div>
                    <div className="me-appr-actions">
                      <button className="me-btn me-btn-sm" onClick={() => onModal("details", item)}>View</button>
                    </div>
                  </div>
                </div>
              );
            })
          }
          <div style={{ paddingTop: 10, display: "flex", justifyContent: "center" }}>
            <button className="me-btn me-btn-ghost" onClick={() => onNav("approval-queue")}>View Full Queue →</button>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div className="me-card">
            <div className="me-card-head">
              <div>
                <div className="me-card-title">Team Summary</div>
              </div>
            </div>
            <div className="me-mini-stats" style={{ marginBottom: 14 }}>
              <div className="me-mini-stat"><div className="me-ms-val">{teamDashboard?.memberCount || 0}</div><div className="me-ms-lbl">Team Members</div></div>
              <div className="me-mini-stat"><div className="me-ms-val">{teamDashboard?.totalExpenses || 0}</div><div className="me-ms-lbl">Expenses Filed</div></div>
              <div className="me-mini-stat"><div className="me-ms-val" style={{ color: "var(--green)" }}>{teamDashboard?.approvalRate || 0}%</div><div className="me-ms-lbl">Approval Rate</div></div>
            </div>
            <div className="me-bar-chart">
              {memberRows.length === 0
                ? <div className="me-empty">No team data yet</div>
                : memberRows.map((row) => (
                  <div key={row.name} className="me-bar-row">
                    <div className="me-bar-label">{row.name}</div>
                    <div className="me-bar-track"><div className="me-bar-fill" style={{ width: `${Math.round((Number(row.total) / maxMember) * 100)}%`, background: "var(--accent)" }} /></div>
                    <div className="me-bar-val">{fmtCurrency(row.total)}</div>
                  </div>
                ))}
            </div>
          </div>
          <div className="me-card">
            <div className="me-card-head"><div className="me-card-title">Category Split</div></div>
            <div className="me-donut-wrap">
              <div className="me-donut" />
              <div className="me-legend">
                {catRows.length === 0
                  ? <div className="me-empty">No data</div>
                  : catRows.map((row, i) => (
                    <div className="me-leg-item" key={row.name}><span className="me-leg-dot" style={{ background: CAT_COLORS[i] }} /><span className="me-leg-lbl">{row.name}</span><span className="me-leg-val">{fmtCurrency(row.total)}</span></div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="me-card">
        <div className="me-card-head">
          <div>
            <div className="me-card-title">Team Expense History</div>
            <div className="me-card-sub">All team members · Recent activity</div>
          </div>
          <button className="me-btn me-btn-sm" onClick={() => onNav("team-expenses")}><Mi icon="open_in_new" />Full View</button>
        </div>
        <div className="me-table-wrap">
          <table className="me-table">
            <thead><tr><th>Expense Id</th><th>Employee</th><th>Category</th><th>Amount</th><th>Date</th><th>Status</th><th /></tr></thead>
            <tbody>
              {recentHistory.length === 0
                ? <tr><td colSpan={7} className="me-empty">No team expenses yet</td></tr>
                : recentHistory.map((row, i) => {
                  const avColors = ["me-av-blue","me-av-green","me-av-orange","me-av-violet","me-av-teal"];
                  return (
                    <tr key={row.id}>
                      <td><span className="me-link" onClick={() => onModal("details", row)}>{row.id}</span></td>
                      <td><div style={{ display: "flex", alignItems: "center", gap: 8 }}><div className={`me-av ${avColors[i % 5]}`} style={{ width: 26, height: 26, fontSize: 10 }}>{initialOf(row.employee)}</div>{row.employee || "—"}</div></td>
                      <td><span className="me-cat">{row.category}</span></td>
                      <td style={{ fontWeight: 700 }}>{fmtCurrency(row.amount)}</td>
                      <td style={{ color: "var(--text3)" }}>{row.date}</td>
                      <td><Pill status={row.status} /></td>
                      <td><button className="me-btn me-btn-ghost" onClick={() => onModal("details", row)}>View</button></td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function MyExpensesPage({ items, myStats, filter, setFilter, onNav, onModal, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);
  const filtered = items.filter((item) => filter === "all" || item.status === filter);
  const pendingCount = items.filter(e => e.status === "Pending L1" || e.status === "Pending L2").length;
  const pendingTotal = items.filter(e => e.status === "Pending L1" || e.status === "Pending L2").reduce((s, e) => s + Number(e.amount || 0), 0);
  const stats = [
    { label: "Total This Month", value: fmtCurrency(myStats?.totalThisMonth || 0), sub: `${items.filter(e => e.status !== "Draft").length} expenses`, icon: "receipt", tone: "blue" },
    { label: "Pending Approval", value: String(myStats?.pendingApproval ?? pendingCount), sub: fmtCurrency(pendingTotal) + " total", icon: "hourglass_empty", tone: "amber" },
    { label: "Approved & Pending Reimb.", value: fmtCurrency(myStats?.approvedPendingReimb || 0), sub: `${items.filter(e => e.status === "Approved").length} expense(s)`, icon: "check_circle", tone: "green" },
    { label: "Reimbursed YTD", value: fmtCurrency(myStats?.reimbursedYTD || 0), sub: "Year to date", icon: "payments", tone: "violet" },
  ];
  return (
    <div className="me-page">
      <div className="me-card-head">
        <div>
          <div className="me-card-title" style={{ fontSize: 20 }}>My Expenses</div>
          <div className="me-card-sub">Track drafts, approvals, and reimbursements</div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="me-btn me-btn-primary" onClick={() => onModal("submit-expense", null)}><Mi icon="add" /> New Expense</button>
        </div>
      </div>

      <div className="me-stat-grid">
        {stats.map((stat) => (
          <div key={stat.label} className="me-kpi">
            <div className="me-kpi-top"><div className="me-kpi-label">{stat.label}</div><div className={`me-kpi-icon ${toneClass(stat.tone)}`}><Mi icon={stat.icon} /></div></div>
            <div className="me-kpi-val">{stat.value}</div>
            <div className="me-kpi-trend">{stat.sub}</div>
          </div>
        ))}
      </div>

      <div className="me-card">
        <div className="me-card-head">
          <div className="me-tabs" style={{ marginBottom: 0, borderBottom: "none" }}>
            {["all", "Pending L1", "Pending L2", "Approved", "Reimbursed", "Rejected"].map((tab) => (
              <button key={tab} className={`me-tab ${filter === tab ? "active" : ""}`} onClick={() => { setFilter(tab); setPage(0); }}>
                {tab === "all" ? "All" : tab}
                {tab !== "all" && <span style={{ marginLeft: 5, fontSize: 11, opacity: 0.7 }}>({items.filter(e => e.status === tab).length})</span>}
              </button>
            ))}
          </div>
        </div>
        <div className="me-table-wrap">
          <table className="me-table">
            <thead>
              <tr><th>Expense ID</th><th>Title</th><th>Category</th><th>Date</th><th>Amount</th><th>Status</th><th>Action</th></tr>
            </thead>
            <tbody>
              {filtered.length === 0
                ? <tr><td colSpan={7} style={{ textAlign: "center", padding: "32px 0", color: "var(--me-text3, #9EA2B8)", fontSize: 13 }}>No expenses found</td></tr>
                : filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((item) => (
                  <tr key={item.id}>
                    <td><span className="me-link" onClick={() => onModal("details", item)}>{item.id}</span></td>
                    <td>{item.title}</td>
                    <td><span className="me-cat">{item.category}</span></td>
                    <td>{item.date}</td>
                    <td>{fmtCurrency(item.amount)}</td>
                    <td><Pill status={item.status} /></td>
                    <td><button className="me-btn me-btn-sm" onClick={() => onModal("details", item)}>View</button></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div className="me-pagination">
          <span className="me-pagination-info">
            {filtered.length === 0 ? "0 expenses" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, filtered.length)} of ${filtered.length}`}
          </span>
          <div className="me-pagination-btns">
            <button className="me-btn me-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="me-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))}</span>
            <button className="me-btn me-btn-sm" disabled={page >= Math.ceil(filtered.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function SubmitExpenseModal({ categories, onClose, onSubmitted }) {
  const [form, setForm] = useState({
    title: "", categoryId: "", amount: "",
    expenseDate: new Date().toISOString().split("T")[0],
    paymentMode: "Personal Card", description: "", project: "",
  });
  const [receipt, setReceipt] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const submit = async () => {
    if (!form.title || !form.categoryId || !form.amount) {
      toast.warning("Please complete title, category, and amount.");
      return;
    }
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("title", form.title);
      fd.append("categoryId", form.categoryId);
      fd.append("amount", form.amount);
      fd.append("expenseDate", form.expenseDate);
      fd.append("paymentMode", form.paymentMode);
      if (form.description) fd.append("description", form.description);
      if (form.project) fd.append("project", form.project);
      if (receipt) {
        const base64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = ev => resolve(ev.target.result);
          reader.onerror = reject;
          reader.readAsDataURL(receipt);
        });
        fd.append("receiptBase64", base64);
        fd.append("receiptFileName", receipt.name);
      }
      const res = await fetch(`${API_BASE_URL}/api/expenses`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: fd,
      });
      if (res.ok) { toast.success("Expense submitted for approval!"); onSubmitted && onSubmitted(); onClose(); }
      else { toast.error(await res.text() || "Failed to submit expense"); }
    } catch { toast.error("Network error"); }
    finally { setSubmitting(false); }
  };

  return (
    <Modal
      title="Submit New Expense"
      onClose={onClose}
      footer={
        <>
          
          <button className="me-btn me-btn-primary" onClick={submit} disabled={submitting}>
            <Mi icon="send" />{submitting ? "Submitting..." : "Submit"}
          </button>
          <button className="me-btn" onClick={onClose}>Cancel</button>
        </>
      }
    >
      <div className="me-form-grid">
        <div className="me-field">
          <label className="me-label">Expense Title *</label>
          <input className="me-input" value={form.title} onChange={e => set("title", e.target.value)} placeholder="e.g. Client dinner at Taj" />
        </div>
        <div className="me-field">
          <label className="me-label">Category *</label>
          <select className="me-select" value={form.categoryId} onChange={e => set("categoryId", e.target.value)}>
            <option value="">Select category</option>
            {(categories || []).map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
        <div className="me-field">
          <label className="me-label">Amount (₹) *</label>
          <input className="me-input" type="number" value={form.amount} onChange={e => set("amount", e.target.value)} placeholder="0.00" />
        </div>
        <div className="me-field">
          <label className="me-label">Expense Date *</label>
          <input className="me-input" type="date" value={form.expenseDate} onChange={e => set("expenseDate", e.target.value)} />
        </div>
        <div className="me-field">
          <label className="me-label">Payment Mode</label>
          <select className="me-select" value={form.paymentMode} onChange={e => set("paymentMode", e.target.value)}>
            <option>Personal Card</option>
            <option>Corporate Card</option>
            <option>UPI</option>
            <option>Cash</option>
            <option>Bank Transfer</option>
          </select>
        </div>
        <div className="me-field">
          <label className="me-label">Project (Optional)</label>
          <input className="me-input" value={form.project} onChange={e => set("project", e.target.value)} placeholder="Project name or code" />
        </div>
      </div>
      <div className="me-field" style={{ marginTop: 12 }}>
        <label className="me-label">Description</label>
        <textarea className="me-textarea" value={form.description} onChange={e => set("description", e.target.value)} placeholder="Business purpose, attendees, project reference..." />
      </div>
      <div className="me-field" style={{ marginTop: 12 }}>
        <label className="me-label">Attach Receipt / Invoice</label>
        <div
          style={{ border: "2px dashed var(--border2)", borderRadius: 10, padding: "20px 16px", textAlign: "center", cursor: "pointer", background: "var(--surface2)", transition: "border-color .15s" }}
          onClick={() => document.getElementById("me-receipt-upload").click()}
          onMouseEnter={e => e.currentTarget.style.borderColor = "var(--accent)"}
          onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border2)"}
        >
          <Mi icon="cloud_upload" />
          <div style={{ fontSize: 13, color: receipt ? "var(--green)" : "var(--text2)", marginTop: 6, fontWeight: receipt ? 600 : 400 }}>
            {receipt ? receipt.name : "Click to upload or drag & drop"}
          </div>
          <div style={{ fontSize: 11, color: "var(--text3)", marginTop: 4 }}>PDF, JPG, PNG · Max 10MB · Required if amount ≥ ₹500</div>
        </div>
        <input id="me-receipt-upload" type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: "none" }} onChange={e => setReceipt(e.target.files[0] || null)} />
      </div>
    </Modal>
  );
}

const downloadClaimSlip = (claim) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 22;
  const cW = W - margin * 2;
  const dark = [24, 25, 42], muted = [100, 102, 120], border = [220, 222, 232], blue = [37, 99, 235], green = [22, 163, 74], violet = [124, 58, 237];
  const tc = (c) => doc.setTextColor(c[0], c[1], c[2]);
  const dc = (c) => doc.setDrawColor(c[0], c[1], c[2]);
  const hline = (y) => { dc(border); doc.setLineWidth(0.3); doc.line(margin, y, W - margin, y); };

  doc.setFont("helvetica", "bold"); doc.setFontSize(13); tc(blue);
  doc.text("Balsuite ", margin, 22);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); tc(muted);
  doc.text("Claim Reimbursement Slip", margin, 28);
  doc.setFont("courier", "normal"); doc.setFontSize(9); tc(blue);
  doc.text(claim.id || "—", W - margin, 22, { align: "right" });
  doc.setFont("helvetica", "bold"); doc.setFontSize(8); tc(green);
  doc.text("Reimbursed", W - margin, 28, { align: "right" });
  hline(34);

  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text("Total reimbursed", margin, 44);
  doc.setFont("helvetica", "bold"); doc.setFontSize(26); tc(green);
  doc.text(`Rs. ${Number(claim.total).toLocaleString("en-IN")}`, margin, 56);
  hline(63);

  const fields = [
    ["Claim ID",     claim.id                         || "—"],
    ["Period",       claim.period                      || "—"],
    ["Title",        claim.title                       || "—"],
    ["No. expenses", String(claim.items ?? "—")              ],
    ["Employee",     claim.employee                    || "—"],
    ["Status",       claim.statusLabel || claim.status || "—"],
  ];
  const colW = cW / 2, cellH = 14;
  let y = 70;
  for (let i = 0; i < fields.length; i += 2) {
    [0, 1].forEach((col) => {
      const f = fields[i + col]; if (!f) return;
      const x = margin + col * colW;
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted); doc.text(f[0], x, y);
      const isStatus = f[0] === "Status", isId = f[0] === "Claim ID", isPeriod = f[0] === "Period";
      doc.setFont("helvetica", "bold"); doc.setFontSize(11);
      tc(isStatus ? green : isId ? blue : isPeriod ? violet : dark); doc.text(String(f[1]), x, y + 7);
    });
    y += cellH;
  }
  hline(y + 4);

  const genDate = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text(`Generated ${genDate}  ·  Balsuite Expense Management System`, W / 2, y + 11, { align: "center" });
  doc.save(`claim-slip-${claim.id}.pdf`);
};

function ClaimsPage({ claims, onModal, onRefresh }) {
  const [search, setSearch] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);
  const arr = claims || [];

  const filtered = arr.filter(c => {
    const txt = `${c.id} ${c.title}`.toLowerCase();
    return !search || txt.includes(search.toLowerCase());
  });

  const totalAmt = arr.reduce((s, c) => s + Number(c.total || 0), 0);
  const reimbursedAmt = arr.filter(c => c.status === "Reimbursed").reduce((s, c) => s + Number(c.total || 0), 0);
  const pendingCount = arr.filter(c => ["Pending L1", "Pending L2", "Submitted"].includes(c.status)).length;

  return (
    <div className="me-page">
      <div className="me-card-head">
        <div>
          <div className="me-card-title" style={{ fontSize: 20 }}>My Claims</div>
          <div className="me-card-sub">Grouped expense submissions for reimbursement</div>
        </div>
      </div>

      <div className="me-stat-grid">
        {[
          { label: "Total Claims", value: String(arr.length), sub: `${fmtCurrency(totalAmt)} total value`, icon: "folder_open", tone: "blue" },
          { label: "Pending", value: String(pendingCount), sub: "Awaiting approval", icon: "hourglass_empty", tone: "amber" },
          { label: "Reimbursed", value: String(arr.filter(c => c.status === "Reimbursed").length), sub: fmtCurrency(reimbursedAmt), icon: "payments", tone: "green" },
          { label: "Rejected", value: String(arr.filter(c => c.status === "Rejected").length), sub: "Not approved", icon: "cancel", tone: "red" },
        ].map(s => (
          <div key={s.label} className="me-kpi">
            <div className="me-kpi-top"><div className="me-kpi-label">{s.label}</div><div className={`me-kpi-icon ${toneClass(s.tone)}`}><Mi icon={s.icon} /></div></div>
            <div className="me-kpi-val">{s.value}</div>
            <div className="me-kpi-trend">{s.sub}</div>
          </div>
        ))}
      </div>

      <div className="me-card" style={{ padding: 0, overflow: "hidden" }}>
        <div style={{ display: "flex", gap: 10, padding: "14px 16px", borderBottom: "1px solid var(--border)", flexWrap: "wrap" }}>
          <input className="me-input" style={{ flex: 1, minWidth: 180 }} placeholder="Search by claim # or title..." value={search} onChange={e => { setSearch(e.target.value); setPage(0); }} />
          <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); setPage(0); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <div className="me-table-wrap" style={{ border: "none", borderRadius: 0 }}>
          <table className="me-table">
            <thead>
              <tr><th>Claim Id</th><th>Title</th><th>Period</th><th style={{ textAlign: "center" }}>Expenses</th><th>Total</th><th>Status</th><th /></tr>
            </thead>
            <tbody>
              {filtered.length === 0
                ? <tr><td colSpan={7} className="me-empty">{arr.length === 0 ? "No claims yet. Claims are created automatically when you submit expenses." : "No claims match your filter."}</td></tr>
                : filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map(c => (
                  <tr key={c.id}>
                    <td><span className="me-link" onClick={() => onModal("claim", c)}>{c.id}</span></td>
                    <td style={{ fontWeight: 500 }}>{c.title}</td>
                    <td style={{ color: "var(--text3)" }}>{c.period || "—"}</td>
                    <td style={{ textAlign: "center" }}>{c.items}</td>
                    <td style={{ fontWeight: 700 }}>{fmtCurrency(c.total || 0)}</td>
                    <td><Pill status={c.status} /></td>
                    <td>
                      {c.status === "Reimbursed"
                        ? <button className="me-btn me-btn-sm me-btn-primary" onClick={() => downloadClaimSlip(c)}><Mi icon="download" />Slip</button>
                        : <button className="me-btn me-btn-sm" onClick={() => onModal("claim", c)}>View</button>}
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>
        <div className="me-pagination">
          <span className="me-pagination-info">
            {filtered.length === 0 ? "0 claims" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, filtered.length)} of ${filtered.length}`}
          </span>
          <div className="me-pagination-btns">
            <button className="me-btn me-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="me-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(filtered.length / PAGE_SIZE))}</span>
            <button className="me-btn me-btn-sm" disabled={page >= Math.ceil(filtered.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function TeamExpensesPage({ items, filters, setFilters, categories, onModal, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);
  const visible = items.filter((item) => {
    const q = (filters.search || "").trim().toLowerCase();
    const statusOk = !filters.status || item.status === filters.status;
    const catOk = !filters.category || item.category === filters.category;
    const searchOk = !q || [item.id, item.employee, item.title, item.dept].join(" ").toLowerCase().includes(q);
    return statusOk && catOk && searchOk;
  });
  return (
    <div className="me-page">
      <div className="me-card-head">
        <div>
          <div className="me-card-title" style={{ fontSize: 20 }}>Team Expenses</div>
          <div className="me-card-sub">Filter, review, and inspect team submissions · {visible.length} record{visible.length !== 1 ? "s" : ""}</div>
        </div>
      </div>
      <div className="me-card" style={{ display: "flex", flexDirection: "column", gap: 0 }}>
        {/* Filter bar */}
        <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", paddingBottom: 14 }}>
          <input className="me-input" style={{ flex: 1, minWidth: 180 }} placeholder="Search employee, expense, department" value={filters.search} onChange={(e) => { const v = e.target.value; setFilters(f => ({ ...f, search: v })); setPage(0); }} />
          <select className="me-select" style={{ width: 150 }} value={filters.status} onChange={(e) => { setFilters((f) => ({ ...f, status: e.target.value })); setPage(0); }}>
            <option value="">All statuses</option>
            <option>Pending L1</option>
            <option>Info Requested</option>
            <option>Approved</option>
            <option>Rejected</option>
          </select>
          <select className="me-select" style={{ width: 150 }} value={filters.category} onChange={(e) => { setFilters((f) => ({ ...f, category: e.target.value })); setPage(0); }}>
            <option value="">All categories</option>
            {(categories || []).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
          </select>
          <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); setPage(0); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button className="me-btn" onClick={() => { setFilters({ search: "", status: "", category: "" }); setPage(0); }}>Reset</button>
        </div>

        {/* Scrollable table — header stays sticky, rows scroll */}
        <div className="me-table-wrap me-table-scroll">
          <table className="me-table">
            <thead>
              <tr>
                <th>Expense</th>
                <th>Employee</th>
                <th>Department</th>
                <th>Category</th>
                <th>Amount</th>
                <th>Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {visible.length === 0
                ? <tr><td colSpan={8} className="me-empty">No expenses match your filters.</td></tr>
                : visible.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((item) => (
                  <tr key={item.id}>
                    <td><span className="me-link" onClick={() => onModal("details", item)}>{item.id}</span><div style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>{item.title}</div></td>
                    <td>{item.employee || "—"}</td>
                    <td style={{ color: "var(--text2)" }}>{item.dept || "—"}</td>
                    <td><span className="me-cat">{item.category}</span></td>
                    <td style={{ fontWeight: 700 }}>{fmtCurrency(item.amount)}</td>
                    <td style={{ color: "var(--text3)", whiteSpace: "nowrap" }}>{item.date ? new Date(item.date).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—"}</td>
                    <td><Pill status={item.status} /></td>
                    <td><button className="me-btn me-btn-sm" onClick={() => onModal("details", item)}>View</button></td>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="me-pagination">
          <span className="me-pagination-info">
            {visible.length === 0 ? "0 expenses" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, visible.length)} of ${visible.length}`}
          </span>
          <div className="me-pagination-btns">
            <button className="me-btn me-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="me-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(visible.length / PAGE_SIZE))}</span>
            <button className="me-btn me-btn-sm" disabled={page >= Math.ceil(visible.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ApprovalQueuePage({ queue, onModal, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const [page, setPage] = useState(0);
  const overSla = queue.filter(item => Number((item.age || "0").replace(/\D/g, "") || 0) >= 4).length;
  return (
    <div className="me-page">
      {overSla > 0 && <div className="me-alert me-as-red"><Mi icon="schedule" />{overSla} expense{overSla !== 1 ? "s are" : " is"} overdue for review. Late approvals impact the reimbursement cycle.</div>}
      <div className="me-card">
        <div className="me-card-head">
          <div>
            <div className="me-card-title">Approval Queue</div>
            <div className="me-card-sub">Prioritize pending submissions and information requests</div>
          </div>
          <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); setPage(0); }}>
            {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
        <div className="me-table-wrap" style={{ marginTop: 14 }}>
          <table className="me-table">
            <thead>
              <tr>
                <th>Expense Id</th>
                <th>Title</th>
                <th>Employee</th>
                <th>Category</th>
                <th>Amount</th>
                <th>Age</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {queue.length === 0
                ? <tr><td colSpan={8} className="me-empty">All caught up. No pending items.</td></tr>
                : queue.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE).map((item, idx) => {
                  const avColors = ["me-av-blue","me-av-green","me-av-orange","me-av-violet","me-av-teal"];
                  return (
                    <tr key={item.id}>
                      <td><span className="me-link" onClick={() => onModal("details", item)}>{item.id}</span></td>
                      <td>{item.title || "—"}</td>
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                          <div className={`me-av ${avColors[idx % 5]}`} style={{ width: 28, height: 28, fontSize: 11 }}>{initialOf(item.employee)}</div>
                          {item.employee || "—"}
                        </div>
                      </td>
                      <td><span className="me-cat">{item.category}</span></td>
                      <td style={{ fontWeight: 700 }}>{fmtCurrency(item.amount)}</td>
                      <td style={{ color: "var(--text3)" }}>{item.age || "—"}</td>
                      <td><Pill status={item.status} /></td>
                      <td>
                        <div style={{ display: "flex", gap: 5, flexWrap: "wrap" }}>
                          <button className="me-btn me-btn-sm" onClick={() => onModal("details", item)}>View</button>
                          <button className="me-btn me-btn-sm me-btn-danger" onClick={() => onModal("reject", item)}>Reject</button>
                          <button className="me-btn me-btn-sm me-btn-success" onClick={() => onModal("approve", item)}>Approve</button>
                        </div>
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
        <div className="me-pagination">
          <span className="me-pagination-info">
            {queue.length === 0 ? "0 items" : `Showing ${page * PAGE_SIZE + 1}–${Math.min((page + 1) * PAGE_SIZE, queue.length)} of ${queue.length}`}
          </span>
          <div className="me-pagination-btns">
            <button className="me-btn me-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>← Prev</button>
            <span className="me-pagination-page">Page {page + 1} of {Math.max(1, Math.ceil(queue.length / PAGE_SIZE))}</span>
            <button className="me-btn me-btn-sm" disabled={page >= Math.ceil(queue.length / PAGE_SIZE) - 1} onClick={() => setPage(p => p + 1)}>Next →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function AnalyticsPage({ teamAnalytics, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const catRows = (teamAnalytics?.catRows || []).slice(0, 5);
  const topContributors = teamAnalytics?.topContributors || [];
  const totalApproved = teamAnalytics?.totalApproved || 0;
  const approvalRate = teamAnalytics?.approvalRate || 0;
  const reimbursedCount = teamAnalytics?.reimbursedCount || 0;
  const overSla = teamAnalytics?.overSlaCount || 0;
  const CAT_COLORS = ["var(--accent)", "var(--green)", "var(--amber)", "var(--violet)", "var(--red)"];
  const avColors = ["me-av-blue", "me-av-green", "me-av-orange", "me-av-violet", "me-av-teal"];

  return (
    <div className="me-page">
      <div className="me-card-head">
        <div>
          <div className="me-card-title" style={{ fontSize: 20 }}>Team Analytics</div>
          <div className="me-card-sub">Spending patterns, approval efficiency, and category mix</div>
        </div>
        <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="me-three-col">
        <div className="me-card">
          <div className="me-card-title">Category Mix</div>
          {catRows.length === 0
            ? <div className="me-empty">No data yet</div>
            : <div className="me-donut-wrap">
                <div className="me-donut" />
                <div className="me-legend">
                  {catRows.map((row, i) => (
                    <div className="me-leg-item" key={row.name}><span className="me-leg-dot" style={{ background: CAT_COLORS[i] }} /><span className="me-leg-lbl">{row.name}</span><span className="me-leg-val">{fmtCurrency(row.total)}</span></div>
                  ))}
                </div>
              </div>
          }
        </div>
        <div className="me-card">
          <div className="me-card-title">Approval Performance</div>
          <div className="me-timeline" style={{ marginTop: 12 }}>
            <div className="me-tl-item">
              <div className="me-tl-dot me-ki-green"><Mi icon="bolt" /></div>
              <div><div className="me-tl-title">Approval rate</div><div className="me-tl-desc">{approvalRate}% of submitted expenses approved</div><div className="me-tl-time">{totalApproved} approved this period</div></div>
            </div>
            <div className="me-tl-item">
              <div className={`me-tl-dot ${overSla > 0 ? "me-ki-red" : "me-ki-green"}`}><Mi icon="schedule" /></div>
              <div><div className="me-tl-title">Aging queue</div><div className="me-tl-desc">{overSla > 0 ? `${overSla} expense${overSla !== 1 ? "s" : ""} waiting over 3 days` : "No overdue items"}</div><div className="me-tl-time">{overSla > 0 ? "Needs attention" : "All on time"}</div></div>
            </div>
            <div className="me-tl-item">
              <div className="me-tl-dot me-ki-blue"><Mi icon="task_alt" /></div>
              <div><div className="me-tl-title">Closure rate</div><div className="me-tl-desc">{reimbursedCount} reimbursement{reimbursedCount !== 1 ? "s" : ""} completed</div><div className="me-tl-time">This period</div></div>
            </div>
          </div>
        </div>
        <div className="me-card">
          <div className="me-card-title">Top Contributors</div>
          {topContributors.length === 0
            ? <div className="me-empty">No team data yet</div>
            : topContributors.map((c, i) => (
              <div key={c.employee} className="me-member-row">
                <div className={`me-av ${avColors[i % 5]}`} style={{ width: 34, height: 34, fontSize: 12 }}>{initialOf(c.employee)}</div>
                <div className="me-mem-info"><div className="me-mem-name">{c.employee}</div><div className="me-mem-role">{c.count} expense{c.count !== 1 ? "s" : ""}</div></div>
                <div className="me-mem-right"><div className="me-mem-amt">{fmtCurrency(c.total)}</div></div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

function ReportsPage({ teamReportsCounts, teamAnalytics, teamBudget, budgets, onRefresh }) {
  const [downloading, setDownloading] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());

  const total      = teamReportsCounts?.totalCount    || 0;
  const pending    = teamReportsCounts?.pendingL1Count || 0;
  const approved   = teamReportsCounts?.approvedCount  || 0;
  const catCount   = teamReportsCounts?.categoryCount  || 0;
  const reimbCount = teamAnalytics?.reimbursedCount    || 0;
  const totalSpent = Number(teamBudget?.totalSpent     || 0);
  const totalPend  = Number(teamBudget?.totalPending   || 0);

  const CAT_COLORS = ["var(--accent)", "var(--green)", "var(--amber)", "var(--violet)", "var(--teal)", "var(--red)"];

  const catRows = useMemo(() => {
    const now = new Date();
    const curPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    // aggregate allocated amount per category from budgets (current month, specific category entries only)
    const allocMap = {};
    (budgets || [])
      .filter(b => (b.period === curPeriod || !b.period) && b.category && b.category !== "Overall")
      .forEach(b => {
        const key = b.category;
        allocMap[key] = (allocMap[key] || 0) + Number(b.allocatedAmount || 0);
      });
    return (teamAnalytics?.catRows || []).slice(0, 6).map(c => {
      const spent = Number(c.total || 0);
      const alloc = allocMap[c.name] || 0;
      const remain = alloc > 0 ? alloc - spent : null;
      const pct = alloc > 0 ? Math.min(100, Math.round((spent / alloc) * 100)) : null;
      return { name: c.name, spent, alloc, remain, pct };
    });
  }, [teamAnalytics, budgets]);

  const contributors = teamAnalytics?.topContributors || [];
  const avColors = ["me-av-blue", "me-av-green", "me-av-orange", "me-av-violet", "me-av-teal"];

  const STATUS_META = [
    { key: "Pending L1",     label: "Pending L1",     color: "#f59e0b" },
    { key: "Pending L2",     label: "Pending L2",     color: "#f97316" },
    { key: "Info Requested", label: "Info Requested", color: "#6366f1" },
    { key: "Approved",       label: "Approved",       color: "#10b981" },
    { key: "Reimbursed",     label: "Reimbursed",     color: "#3b82f6" },
    { key: "Rejected",       label: "Rejected",       color: "#ef4444" },
  ];

  const budgetData = useMemo(() => {
    const now = new Date();
    const curPeriod = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    const active = (budgets || []).filter(b => b.period === curPeriod || !b.period);
    const totalAlloc  = active.reduce((s, b) => s + Number(b.allocatedAmount || 0), 0);
    const totalBSpent = active.reduce((s, b) => s + Number(b.spentAmount || 0), 0);
    const overBudget  = active.filter(b => Number(b.spentAmount || 0) > Number(b.allocatedAmount || 0)).length;
    const rows = active
      .map(b => {
        const alloc = Number(b.allocatedAmount || 0);
        const spent = Number(b.spentAmount || 0);
        const pct = alloc > 0 ? Math.min(100, Math.round((spent / alloc) * 100)) : 0;
        return { dept: b.department, cat: b.category || "Overall", alloc, spent, remain: alloc - spent, pct };
      })
      .sort((a, b) => b.pct - a.pct)
      .slice(0, 6);
    return { totalAlloc, totalBSpent, remain: totalAlloc - totalBSpent, overBudget, rows, count: active.length };
  }, [budgets]);

  const downloadExcel = async (type) => {
    setDownloading(type);
    try {
      const res = await fetch(`${API_BASE_URL}/api/expenses/team/export?type=${type}&year=${year}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (!res.ok) { toast.error("Failed to generate report"); return; }
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `team-${type}-${new Date().toISOString().split("T")[0]}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Report downloaded successfully.");
    } catch { toast.error("Download failed"); }
    finally { setDownloading(null); }
  };

  const reports = [
    { key: "summary",  title: "Expense Summary",      desc: `All ${total} team expenses`,              icon: "summarize",       tone: "blue",   count: total,    unit: "expenses" },
    { key: "pending",  title: "Pending Approvals",     desc: `${pending} awaiting your approval`,       icon: "pending_actions", tone: "amber",  count: pending,  unit: "pending" },
    { key: "category", title: "Category Spend",        desc: `Across ${catCount} categories`,           icon: "donut_small",     tone: "green",  count: catCount, unit: "categories" },
    { key: "approved", title: "Approved & Reimbursed", desc: `${approved} expenses cleared`,            icon: "check_circle",    tone: "violet", count: approved, unit: "approved" },
  ];

  return (
    <div className="me-page">

      {/* Page header */}
      <div className="me-card-head">
        <div>
          <div className="me-card-title" style={{ fontSize: 20 }}>Reports & Analytics</div>
          <div className="me-card-sub">Team expense overview · {total} total transactions</div>
        </div>
        <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>

      {/* KPI strip — inline flex, never collapses */}
      <div style={{ display: "flex", flexShrink: 0, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10 }}>
        {[
          { label: "Total Team Expenses", val: total,                color: "var(--accent)"  },
          { label: "Pending Approval",    val: pending,              color: pending > 0 ? "#f59e0b" : "var(--text)" },
          { label: "Approved",            val: approved,             color: "var(--green)"   },
          { label: "Reimbursed",          val: reimbCount,           color: "#3b82f6"        },
          { label: "Total Spent",         val: fmtCurrency(totalSpent), color: "var(--text)" },
          { label: "Committed",           val: fmtCurrency(totalPend),  color: totalPend > 0 ? "var(--amber)" : "var(--text)" },
        ].map((m, i, arr) => (
          <div key={m.label} style={{ flex: 1, minWidth: 0, padding: "13px 10px", textAlign: "center", borderRight: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
            <div style={{ fontSize: 17, fontWeight: 800, fontFamily: "'DM Sans',sans-serif", color: m.color, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{m.val}</div>
            <div style={{ fontSize: 10, color: "var(--text3)", marginTop: 3, textTransform: "uppercase", letterSpacing: ".4px", fontFamily: "'DM Sans',sans-serif" }}>{m.label}</div>
          </div>
        ))}
      </div>

      {/* Row 1: Category breakdown + Status distribution */}
      <div className="me-two-col">
        <div className="me-card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
            <div className="me-card-title">Spend by Category</div>
            <span style={{ fontSize: 10, color: "var(--text3)", fontFamily: "'DM Sans',sans-serif" }}>Current month allocation</span>
          </div>
          {catRows.length === 0
            ? <div className="me-empty">No category data yet</div>
            : <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {catRows.map((c, i) => {
                const color = CAT_COLORS[i];
                const isOver = c.alloc > 0 && c.remain < 0;
                const isNear = c.alloc > 0 && !isOver && c.pct >= 90;
                const barColor = isOver ? "#ef4444" : isNear ? "#f59e0b" : color;
                // fallback bar width when no budget: relative to max spent
                const maxSpent = Math.max(...catRows.map(r => r.spent), 1);
                const fallbackPct = Math.round((c.spent / maxSpent) * 100);
                const barPct = c.pct !== null ? c.pct : fallbackPct;
                return (
                  <div key={c.name}>
                    {/* Category name + badges */}
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 6 }}>
                      <span style={{ fontWeight: 700, fontSize: 12, color: "var(--text)" }}>{c.name}</span>
                      {isOver && <span style={{ fontSize: 9, fontWeight: 700, color: "#fff", background: "#ef4444", padding: "1px 6px", borderRadius: 10 }}>OVER</span>}
                      {isNear && !isOver && <span style={{ fontSize: 9, fontWeight: 700, color: "#fff", background: "#f59e0b", padding: "1px 6px", borderRadius: 10 }}>NEAR</span>}
                    </div>
                    {/* Three numbers */}
                    <div style={{ display: "flex", gap: 0, background: "var(--surface2)", borderRadius: 7, overflow: "hidden", marginBottom: 7 }}>
                      {[
                        { lbl: "Allocated", val: c.alloc > 0 ? fmtCurrency(c.alloc) : "—",            clr: color },
                        { lbl: "Spent",     val: fmtCurrency(c.spent),                                 clr: barColor },
                        { lbl: "Remaining", val: c.remain !== null ? fmtCurrency(c.remain) : "—",      clr: c.remain !== null && c.remain < 0 ? "#ef4444" : "var(--green)" },
                      ].map((item, j, arr) => (
                        <div key={item.lbl} style={{ flex: 1, padding: "6px 4px", textAlign: "center", borderRight: j < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
                          <div style={{ fontSize: 11.5, fontWeight: 800, fontFamily: "'DM Sans',sans-serif", color: item.clr, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{item.val}</div>
                          <div style={{ fontSize: 9, color: "var(--text3)", marginTop: 1, textTransform: "uppercase" }}>{item.lbl}</div>
                        </div>
                      ))}
                    </div>
                    {/* Progress bar */}
                    <div style={{ height: 6, background: "var(--surface3)", borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${barPct}%`, background: barColor, borderRadius: 4, transition: "width .4s" }} />
                    </div>
                    {c.pct !== null && (
                      <div style={{ fontSize: 10, color: "var(--text3)", textAlign: "right", marginTop: 2, fontFamily: "'DM Sans',sans-serif" }}>{c.pct}% utilised</div>
                    )}
                  </div>
                );
              })}
            </div>
          }
        </div>
        <div className="me-card">
          <div className="me-card-title" style={{ marginBottom: 14 }}>Status Distribution</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
            {STATUS_META.map(s => {
              const cnt = s.key === "Pending L1" ? pending
                : s.key === "Approved" ? approved
                : s.key === "Reimbursed" ? reimbCount
                : 0;
              const pct = total > 0 ? Math.round((cnt / total) * 100) : 0;
              return (
                <div key={s.key}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 11.5, marginBottom: 3 }}>
                    <span style={{ color: "var(--text2)", fontWeight: 500 }}>{s.label}</span>
                    <span style={{ fontWeight: 700, color: s.color }}>{cnt} <span style={{ color: "var(--text3)", fontWeight: 400 }}>({pct}%)</span></span>
                  </div>
                  <div style={{ height: 6, background: "var(--surface3)", borderRadius: 4, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${pct}%`, background: s.color, borderRadius: 4, transition: "width .4s" }} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Row 2: Budget utilization + Top contributors */}
      <div className="me-two-col">
        <div className="me-card">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
            <div className="me-card-title">Budget Utilization — Current Month</div>
            <span style={{ fontSize: 11, color: "var(--text3)" }}>{budgetData.count} budget{budgetData.count !== 1 ? "s" : ""}</span>
          </div>
          {/* Mini summary */}
          <div style={{ display: "flex", gap: 0, background: "var(--surface2)", borderRadius: 8, overflow: "hidden", marginBottom: 14 }}>
            {[
              { label: "Allocated", val: fmtCurrency(budgetData.totalAlloc), color: "var(--accent)" },
              { label: "Spent",     val: fmtCurrency(budgetData.totalBSpent), color: "#f59e0b" },
              { label: "Remaining", val: fmtCurrency(budgetData.remain), color: budgetData.remain < 0 ? "var(--red)" : "var(--green)" },
            ].map((item, i, arr) => (
              <div key={item.label} style={{ flex: 1, padding: "10px 8px", textAlign: "center", borderRight: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
                <div style={{ fontSize: 14, fontWeight: 800, fontFamily: "'DM Sans',sans-serif", color: item.color }}>{item.val}</div>
                <div style={{ fontSize: 10, color: "var(--text3)", marginTop: 2 }}>{item.label}</div>
              </div>
            ))}
          </div>
          {budgetData.rows.length === 0
            ? <div className="me-empty">No budget data for current month</div>
            : <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
              {budgetData.rows.map(row => {
                const isOver = row.remain < 0;
                const isNear = !isOver && row.pct >= 90;
                const barColor = isOver ? "#ef4444" : isNear ? "#f59e0b" : "var(--accent)";
                return (
                  <div key={`${row.dept}-${row.cat}`}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 11.5, marginBottom: 4 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, minWidth: 0 }}>
                        <span style={{ fontWeight: 600, color: "var(--text)", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 100 }}>{row.dept}</span>
                        <span style={{ fontSize: 10, color: "var(--text3)", background: "var(--surface3)", padding: "1px 6px", borderRadius: 10, flexShrink: 0 }}>{row.cat}</span>
                        {isOver && <span style={{ fontSize: 9, fontWeight: 700, color: "#fff", background: "#ef4444", padding: "1px 5px", borderRadius: 10 }}>OVER</span>}
                        {isNear && !isOver && <span style={{ fontSize: 9, fontWeight: 700, color: "#fff", background: "#f59e0b", padding: "1px 5px", borderRadius: 10 }}>NEAR</span>}
                      </div>
                      <span style={{ fontWeight: 700, color: barColor, fontFamily: "'DM Sans',sans-serif", flexShrink: 0 }}>{row.pct}%</span>
                    </div>
                    <div style={{ height: 6, background: "var(--surface3)", borderRadius: 4, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${Math.min(100, row.pct)}%`, background: barColor, borderRadius: 4, transition: "width .4s" }} />
                    </div>
                  </div>
                );
              })}
            </div>
          }
        </div>
        <div className="me-card">
          <div className="me-card-title" style={{ marginBottom: 14 }}>Top Contributors</div>
          {contributors.length === 0
            ? <div className="me-empty">No team data yet</div>
            : contributors.map((c, i) => (
              <div key={c.employee} className="me-member-row">
                <div className={`me-av ${avColors[i % 5]}`} style={{ width: 32, height: 32, fontSize: 11 }}>{initialOf(c.employee)}</div>
                <div className="me-mem-info">
                  <div className="me-mem-name">{c.employee}</div>
                  <div className="me-mem-role">{c.count} expense{c.count !== 1 ? "s" : ""}</div>
                </div>
                <div className="me-mem-right"><div className="me-mem-amt">{fmtCurrency(c.total)}</div></div>
              </div>
            ))
          }
        </div>
      </div>

      {/* Row 3: Download reports */}
      <div className="me-card">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14 }}>
          <div className="me-card-title">Download Reports</div>
          <span style={{ fontSize: 11, color: "var(--text3)" }}>Exports as Excel (.xlsx)</span>
        </div>
        <div className="me-report-grid">
          {reports.map((report) => (
            <div key={report.key} className="me-report-card" onClick={() => downloadExcel(report.key)}>
              <div className={`me-rc-icon ${toneClass(report.tone)}`}><Mi icon={report.icon} /></div>
              <div className="me-rc-title">{report.title}</div>
              <div className="me-rc-desc">{report.desc}</div>
              <div className="me-rc-footer">
                <span className="me-rc-tag" style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                  {downloading === report.key ? "Downloading..." : <><Mi icon="download" />Excel</>}
                </span>
                <span className="me-rc-tag" style={{ color: "var(--accent)", fontWeight: 700 }}>
                  {report.count} {report.unit}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
}

function BudgetPage({ teamBudget, onRefresh }) {
  const [year, setYear] = useState(new Date().getFullYear());
  const catSpendList = teamBudget?.catSpend || [];
  const catPendingMap = teamBudget?.catPending || {};
  const totalSpent = Number(teamBudget?.totalSpent || 0);
  const totalPending = Number(teamBudget?.totalPending || 0);
  const pendingCount = teamBudget?.pendingCount || 0;
  const totalExpenses = teamBudget?.totalExpenses || 0;
  const activeCount = teamBudget?.activeCount || 0;
  const maxAmt = Number(catSpendList[0]?.total || 1);
  const CAT_TONES = ["amber", "blue", "green", "violet", "teal", "red"];

  const alerts = catSpendList.filter(r => Number(r.total) > 10000).map((r, i) => ({
    cat: r.name, amt: Number(r.total), tone: i === 0 ? "red" : "amber", icon: i === 0 ? "warning" : "priority_high",
  }));

  return (
    <div className="me-page">
      <div className="me-card-head">
        <div>
          <div className="me-card-title" style={{ fontSize: 20 }}>Budget vs Actual</div>
          <div className="me-card-sub">Category spend breakdown · Current period</div>
        </div>
        <select className="me-select" style={{ width: 90 }} value={year} onChange={e => { const y = Number(e.target.value); setYear(y); onRefresh(y); }}>
          {YEAR_OPTIONS.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      </div>
      <div className="me-kpi-row">
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Total Spent</div><div className="me-kpi-icon me-ki-green"><Mi icon="payments" /></div></div><div className="me-kpi-val">{fmtCurrency(totalSpent)}</div><div className="me-kpi-trend">Cleared expenses</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Committed</div><div className="me-kpi-icon me-ki-amber"><Mi icon="pending_actions" /></div></div><div className="me-kpi-val">{fmtCurrency(totalPending)}</div><div className="me-kpi-trend">{pendingCount} pending approval</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Total Exposure</div><div className="me-kpi-icon me-ki-red"><Mi icon="trending_up" /></div></div><div className="me-kpi-val">{fmtCurrency(totalSpent + totalPending)}</div><div className="me-kpi-trend">Spent + pending</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Categories</div><div className="me-kpi-icon me-ki-blue"><Mi icon="donut_small" /></div></div><div className="me-kpi-val">{catSpendList.length}</div><div className="me-kpi-trend">Active spend categories</div></div>
        <div className="me-kpi"><div className="me-kpi-top"><div className="me-kpi-label">Team Expenses</div><div className="me-kpi-icon me-ki-violet"><Mi icon="groups" /></div></div><div className="me-kpi-val">{totalExpenses}</div><div className="me-kpi-trend">{activeCount} active</div></div>
      </div>
      <div className="me-two-col">
        <div className="me-card">
          <div className="me-card-title">Spend by Category</div>
          <div style={{ marginTop: 12 }}>
            {catSpendList.length === 0
              ? <div className="me-empty">No expense data yet</div>
              : catSpendList.map((row, i) => {
                const amt = Number(row.total);
                const pct = Math.round((amt / maxAmt) * 100);
                const tone = CAT_TONES[i % CAT_TONES.length];
                const catPendingAmt = catPendingMap[row.name];
                return (
                  <div key={row.name} className="me-budget-row">
                    <div className="me-budget-dept">{row.name}</div>
                    <div className="me-budget-track">
                      <div className="me-budget-labels">
                        <span className="me-budget-spent" style={{ color: barClass(tone).background }}>{fmtCurrency(amt)}</span>
                        {catPendingAmt ? <span className="me-budget-total">+{fmtCurrency(catPendingAmt)} pending</span> : null}
                      </div>
                      <div className="me-prog-wrap"><div className="me-prog-fill" style={{ width: `${pct}%`, ...barClass(tone) }} /></div>
                    </div>
                    <div className="me-budget-pct" style={{ color: barClass(tone).background }}>{i + 1}</div>
                  </div>
                );
              })
            }
          </div>
        </div>
        <div className="me-card">
          <div className="me-card-title">Budget Alerts</div>
          <div style={{ marginTop: 12, display: "grid", gap: 10 }}>
            {alerts.length === 0
              ? <div className="me-alert me-as-green"><Mi icon="check_circle" /><div><div style={{ fontWeight: 600, fontSize: 12 }}>All categories within normal range</div></div></div>
              : alerts.slice(0, 3).map((a) => (
                <div key={a.cat} className={`me-alert me-as-${a.tone}`}>
                  <Mi icon={a.icon} />
                  <div><div style={{ fontWeight: 600, fontSize: 12 }}>{a.cat} · {fmtCurrency(a.amt)}</div><div style={{ fontSize: 11 }}>High spend category</div></div>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
}

const downloadExpenseSlip = (expense) => {
  const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
  const W = doc.internal.pageSize.getWidth();
  const margin = 22;
  const cW = W - margin * 2;
  const fmtD = (d) => { if (!d) return "—"; try { return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }); } catch { return d; } };
  const dark = [24, 25, 42], muted = [100, 102, 120], border = [220, 222, 232], blue = [37, 99, 235], green = [22, 163, 74], violet = [124, 58, 237];
  const tc = (c) => doc.setTextColor(c[0], c[1], c[2]);
  const dc = (c) => doc.setDrawColor(c[0], c[1], c[2]);
  const hline = (y) => { dc(border); doc.setLineWidth(0.3); doc.line(margin, y, W - margin, y); };

  doc.setFont("helvetica", "bold"); doc.setFontSize(13); tc(blue);
  doc.text("Balsuite ", margin, 22);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); tc(muted);
  doc.text("Expense Reimbursement Slip", margin, 28);
  doc.setFont("courier", "normal"); doc.setFontSize(9); tc(blue);
  doc.text(expense.id || "—", W - margin, 22, { align: "right" });
  doc.setFont("helvetica", "bold"); doc.setFontSize(8); tc(green);
  doc.text("Reimbursed", W - margin, 28, { align: "right" });
  hline(34);

  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text("Amount reimbursed", margin, 44);
  doc.setFont("helvetica", "bold"); doc.setFontSize(26); tc(green);
  doc.text(`Rs. ${Number(expense.amount).toLocaleString("en-IN")}`, margin, 56);
  hline(63);

  const fields = [
    ["Employee",        expense.employee       || "—"],
    ["Department",      expense.dept           || "—"],
    ["Category",        expense.category       || "—"],
    ["Expense date",    fmtD(expense.date)           ],
    ["Payment mode",    expense.payment        || "—"],
    ["Transaction ref", expense.transactionRef || "—"],
    ["Reimbursed on",   fmtD(expense.reimbursedAt) || fmtD(expense.updatedAt) || "—"],
    ["Status",          "Reimbursed"                 ],
  ];
  const colW = cW / 2, cellH = 14;
  let y = 70;
  for (let i = 0; i < fields.length; i += 2) {
    [0, 1].forEach((col) => {
      const f = fields[i + col]; if (!f) return;
      const x = margin + col * colW;
      doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted); doc.text(f[0], x, y);
      const isStatus = f[0] === "Status", isTxn = f[0] === "Transaction ref";
      doc.setFont("helvetica", "bold"); doc.setFontSize(11);
      tc(isStatus ? green : isTxn ? violet : dark); doc.text(String(f[1]), x, y + 7);
    });
    y += cellH;
  }
  hline(y + 4);

  const genDate = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); tc(muted);
  doc.text(`Generated ${genDate}  ·  Balsuite Expense Management System`, W / 2, y + 11, { align: "center" });
  doc.save(`slip-${expense.id}.pdf`);
};

function DetailModalContent({ item, onApprove, onReject, onClose }) {
  const e = item || {};
  const mgr    = e.approvedByManager || "Manager";
  const admin  = e.approvedByAdmin   || "Admin";
  const txnRef = e.transactionRef    || "—";

  const isReimbursed = e.status === "Reimbursed";
  const isApproved   = e.status === "Approved";
  const isRejected   = e.status === "Rejected";
  const isInfo       = e.status === "Info Requested";
  const isPendingL2  = e.status === "Pending L2";

  const trailKey = isInfo ? "info" : isReimbursed ? "reimbursed" : isApproved ? "approved" : isRejected ? "rejected" : isPendingL2 ? "l2" : "pending";

  const TRAILS = {
    pending: [
      { cls: "me-td-green", icon: "check",           title: "Submitted",           desc: `${e.employee || "Employee"} submitted this expense`, time: e.date },
      { cls: "me-td-amber", icon: "schedule",         title: "Pending L1 Review",   desc: "Awaiting manager approval" },
      { cls: "me-td-grey",  icon: "hourglass_empty",  title: "L2 Review (Admin)",   desc: "Not started" },
      { cls: "me-td-grey",  icon: "payments",         title: "Reimbursement",       desc: "Pending" },
    ],
    l2: [
      { cls: "me-td-green", icon: "check",    title: "Submitted",         desc: `${e.employee || "Employee"} submitted this expense`, time: e.date },
      { cls: "me-td-green", icon: "check",    title: "L1 Approved",       desc: mgr },
      { cls: "me-td-amber", icon: "schedule", title: "Pending L2 Review", desc: "Awaiting admin approval" },
      { cls: "me-td-grey",  icon: "payments", title: "Reimbursement",     desc: "Pending" },
    ],
    info: [
      { cls: "me-td-green", icon: "check",           title: "Submitted",               desc: `${e.employee || "Employee"} submitted this expense`, time: e.date },
      { cls: "me-td-blue",  icon: "info",             title: "Clarification Requested", desc: e.infoRequestMessage || "Additional info needed" },
      { cls: "me-td-grey",  icon: "hourglass_empty",  title: "L2 Review (Admin)",       desc: "Not started" },
      { cls: "me-td-grey",  icon: "payments",         title: "Reimbursement",           desc: "Pending" },
    ],
    approved: [
      { cls: "me-td-green",   icon: "check",    title: "Submitted",               desc: `${e.employee || "Employee"} submitted this expense`, time: e.date },
      { cls: "me-td-green",   icon: "check",    title: "L1 Approved",             desc: mgr },
      { cls: "me-td-green",   icon: "check",    title: "L2 Approved",             desc: admin },
      { cls: "me-td-violet",  icon: "schedule", title: "Reimbursement Scheduled", desc: "Pending payment cycle" },
    ],
    reimbursed: [
      { cls: "me-td-green", icon: "check",    title: "Submitted",   desc: `${e.employee || "Employee"} submitted this expense`, time: e.date },
      { cls: "me-td-green", icon: "check",    title: "L1 Approved", desc: mgr },
      { cls: "me-td-green", icon: "check",    title: "L2 Approved", desc: admin },
      { cls: "me-td-green", icon: "check",    title: "Reimbursed",  desc: `Ref: ${txnRef}` },
    ],
    rejected: [
      { cls: "me-td-green", icon: "check",  title: "Submitted", desc: `${e.employee || "Employee"} submitted this expense`, time: e.date },
      { cls: "me-td-red",   icon: "cancel", title: "Rejected",  desc: `${mgr}${e.rejectionReason ? ` – ${e.rejectionReason}` : ""}` },
    ],
  };

  const trail = TRAILS[trailKey] || TRAILS.pending;

  const renderReceipt = () => {
    if (!e.receiptFileName) return null;
    if (!e.receiptBase64) return (
      <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8, marginBottom: 16 }}>
        <Mi icon="attach_file" /><span style={{ fontSize: 13, color: "var(--text2)" }}>{e.receiptFileName}</span>
      </div>
    );
    const ext = e.receiptFileName.split(".").pop().toLowerCase();
    const isImage = ["jpg", "jpeg", "png"].includes(ext);
    const mime = isImage ? `image/${ext === "jpg" ? "jpeg" : ext}` : "application/pdf";
    const dataUrl = e.receiptBase64.startsWith("data:") ? e.receiptBase64 : `data:${mime};base64,${e.receiptBase64}`;
    return (
      <div style={{ marginBottom: 16 }}>
        <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text3)", marginBottom: 8, textTransform: "uppercase", letterSpacing: ".5px" }}>Attached Receipt</div>
        {isImage ? (
          <div>
            <img src={dataUrl} alt={e.receiptFileName} style={{ maxWidth: "100%", maxHeight: 260, borderRadius: 8, border: "1px solid var(--border)", objectFit: "contain", display: "block" }} />
            <a href={dataUrl} download={e.receiptFileName} className="me-btn me-btn-sm" style={{ marginTop: 8, display: "inline-flex", textDecoration: "none" }}><Mi icon="download" />Download</a>
          </div>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: "var(--surface2)", border: "1px solid var(--border)", borderRadius: 8 }}>
            <Mi icon="picture_as_pdf" style={{ fontSize: 30, color: "var(--red)" }} />
            <div style={{ flex: 1 }}><div style={{ fontSize: 13, fontWeight: 600 }}>{e.receiptFileName}</div><div style={{ fontSize: 11, color: "var(--text3)" }}>PDF Document</div></div>
            <a href={dataUrl} download={e.receiptFileName} className="me-btn me-btn-sm me-btn-primary" style={{ textDecoration: "none" }}><Mi icon="download" />Download</a>
          </div>
        )}
      </div>
    );
  };

  return (
    <Modal
      title={e.id || "Expense Detail"}
      onClose={onClose}
      footer={
        <>
          <button className="me-btn" onClick={onClose}>Close</button>
          {isReimbursed && <button className="me-btn me-btn-primary" onClick={() => downloadExpenseSlip(e)}><Mi icon="download" />Download Slip</button>}
          {e.canApprove && <button className="me-btn me-btn-danger" onClick={() => onReject(e)}>Reject</button>}
          {e.canApprove && <button className="me-btn me-btn-success" onClick={() => onApprove(e)}>Approve</button>}
        </>
      }
    >
      <div className={`me-alert ${isRejected ? "me-as-red" : isReimbursed || isApproved ? "me-as-green" : isInfo ? "me-as-amber" : "me-as-blue"}`}>
        <Mi icon={isRejected ? "cancel" : isReimbursed || isApproved ? "check_circle" : isInfo ? "chat_bubble" : "hourglass_top"} />
        <strong>{e.statusLabel || e.status}</strong>
      </div>

      <div className="me-detail-grid">
        <div className="me-detail-row"><div className="me-detail-key">Expense Number</div><div className="me-detail-val" style={{ color: "var(--accent)" }}>{e.id}</div></div>
        <div className="me-detail-row"><div className="me-detail-key">Status</div><div className="me-detail-val"><Pill status={e.status} /></div></div>
        <div className="me-detail-row"><div className="me-detail-key">Category</div><div className="me-detail-val">{e.category || "—"}</div></div>
        <div className="me-detail-row"><div className="me-detail-key">Expense Date</div><div className="me-detail-val">{e.date || "—"}</div></div>
        <div className="me-detail-row"><div className="me-detail-key">Amount</div><div className="me-detail-val" style={{ color: "var(--green)", fontSize: 16 }}>{fmtCurrency(e.amount)}</div></div>
        <div className="me-detail-row"><div className="me-detail-key">Payment Mode</div><div className="me-detail-val">{e.payment || "—"}</div></div>
        {e.employee && <div className="me-detail-row"><div className="me-detail-key">Employee</div><div className="me-detail-val">{e.employee}</div></div>}
        {e.dept    && <div className="me-detail-row"><div className="me-detail-key">Department</div><div className="me-detail-val">{e.dept}</div></div>}
        {e.project && <div className="me-detail-row"><div className="me-detail-key">Project</div><div className="me-detail-val">{e.project}</div></div>}
        {isReimbursed && txnRef !== "—" && <div className="me-detail-row"><div className="me-detail-key">Transaction Ref</div><div className="me-detail-val">{txnRef}</div></div>}
        {e.desc && <div className="me-detail-row me-detail-full"><div className="me-detail-key">Description</div><div className="me-detail-val" style={{ fontWeight: 400, fontSize: 13, color: "var(--text2)" }}>{e.desc}</div></div>}
      </div>

      {renderReceipt()}

      {isRejected && e.rejectionReason && (
        <div className="me-alert me-as-red" style={{ marginBottom: 16 }}>
          <Mi icon="cancel" />
          <div><div style={{ fontWeight: 600, marginBottom: 2 }}>Rejection Reason</div><div>{e.rejectionReason}</div></div>
        </div>
      )}

      {isInfo && e.infoRequestMessage && (
        <div className="me-alert me-as-amber" style={{ marginBottom: 16 }}>
          <Mi icon="warning_amber" />
          <div><div style={{ fontWeight: 600, marginBottom: 2 }}>Clarification Requested</div><div>{e.infoRequestMessage}</div></div>
        </div>
      )}

      <div style={{ fontSize: 11, fontWeight: 700, color: "var(--text3)", marginBottom: 10, textTransform: "uppercase", letterSpacing: ".5px" }}>Approval Trail</div>
      <div className="me-timeline">
        {trail.map((t, i) => (
          <div key={i} className="me-tl-item">
            <div className={`me-tl-dot ${t.cls}`}><Mi icon={t.icon} /></div>
            <div>
              <div className="me-tl-title">{t.title}</div>
              <div className="me-tl-desc">{t.desc}</div>
              {t.time && <div className="me-tl-time">{t.time}</div>}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
}

function ComingSoonPage({ title = "Coming Soon" }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 420, gap: 20, textAlign: "center" }}>
      <div style={{ width: 80, height: 80, borderRadius: "50%", background: "var(--accent-light, #ede9fe)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Mi icon="construction" style={{ fontSize: 38, color: "var(--accent, #7c3aed)" }} />
      </div>
      <div>
        <div style={{ fontSize: 22, fontWeight: 800, color: "var(--text)", marginBottom: 8 }}>{title}</div>
        <div style={{ fontSize: 14, color: "var(--text3, #9ca3af)", fontFamily: "var(--font2, sans-serif)", maxWidth: 340, lineHeight: 1.6 }}>
          This section is under development and will be available soon. Stay tuned!
        </div>
      </div>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#fef3c7", color: "#92400e", border: "1px solid #fcd34d", borderRadius: 20, padding: "5px 16px", fontSize: 12, fontWeight: 600 }}>
        <Mi icon="schedule" style={{ fontSize: 15 }} /> In Progress
      </span>
    </div>
  );
}

export default function ManagerExpenseDashboard() {
  const [activePage, setActivePage] = useState("dashboard");
  const [myExpenses, setMyExpenses] = useState([]);
  const [teamExpenses, setTeamExpenses] = useState([]);
  const [myStats, setMyStats] = useState(null);
  const [myClaims, setMyClaims] = useState([]);
  const [categories, setCategories] = useState([]);
  const [teamQueue, setTeamQueue] = useState([]);
  const [teamDashboard, setTeamDashboard] = useState(null);
  const [teamAnalytics, setTeamAnalytics] = useState(null);
  const [teamBudget, setTeamBudget] = useState(null);
  const [teamReportsCounts, setTeamReportsCounts] = useState(null);
  const [notifOpen, setNotifOpen] = useState(false);
  const [myFilter, setMyFilter] = useState("all");
  const [teamFilters, setTeamFilters] = useState({ search: "", status: "", category: "" });
  const [modal, setModal] = useState(null);
  const [settings, setSettings] = useState({ email: true, reminders: true, budgetAlerts: true });
  const [pageLoading, setPageLoading] = useState(false);
  const [budgets, setBudgets] = useState([]);

  const openModal = (type, data) => setModal({ type, data });
  const closeModal = () => setModal(null);

  const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

  const fetchMyExpenses = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/my?year=${y}`, { headers: h });
    if (r.ok) setMyExpenses(await r.json());
  }, []);

  const fetchStats = useCallback(async () => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const r = await fetch(`${API_BASE_URL}/api/expenses/my/stats`, { headers: h });
    if (r.ok) setMyStats(await r.json());
  }, []);

  const fetchClaims = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expense-claims/my?year=${y}`, { headers: h });
    if (r.ok) setMyClaims(await r.json());
  }, []);

  const fetchCategories = useCallback(async () => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const r = await fetch(`${API_BASE_URL}/api/expense-categories/active`, { headers: h });
    if (r.ok) setCategories(await r.json());
  }, []);

  const fetchTeamExpenses = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/team?year=${y}`, { headers: h });
    if (r.ok) setTeamExpenses(await r.json());
  }, []);

  const fetchTeamQueue = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/team/queue?year=${y}`, { headers: h });
    if (r.ok) setTeamQueue(await r.json());
  }, []);

  const fetchTeamDashboard = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/team/dashboard?year=${y}`, { headers: h });
    if (r.ok) setTeamDashboard(await r.json());
  }, []);

  const fetchTeamAnalytics = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/team/analytics?year=${y}`, { headers: h });
    if (r.ok) setTeamAnalytics(await r.json());
  }, []);

  const fetchTeamBudget = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/team/budget?year=${y}`, { headers: h });
    if (r.ok) setTeamBudget(await r.json());
  }, []);

  const fetchTeamReportsCounts = useCallback(async (year) => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const y = year || new Date().getFullYear();
    const r = await fetch(`${API_BASE_URL}/api/expenses/team/reports-counts?year=${y}`, { headers: h });
    if (r.ok) setTeamReportsCounts(await r.json());
  }, []);

  const fetchBudgets = useCallback(async () => {
    const h = authHeader();
    if (!h.Authorization || h.Authorization === "Bearer null") return;
    const r = await fetch(`${API_BASE_URL}/api/budgets`, { headers: h });
    if (r.ok) setBudgets(await r.json());
  }, []);

  const loadPage = useCallback(async (page) => {
    setPageLoading(true);
    try {
      switch (page) {
        case "dashboard":        await Promise.all([fetchTeamQueue(), fetchTeamDashboard(), fetchStats()]); break;
        case "my-expenses":      await Promise.all([fetchMyExpenses(), fetchStats()]); break;
        case "my-claims":        await fetchClaims(); break;
        case "team-expenses":    await Promise.all([fetchTeamExpenses(), fetchCategories()]); break;
        case "approval-queue":   await fetchTeamQueue(); break;
        case "analytics":        await fetchTeamAnalytics(); break;
        case "reports":          await Promise.all([fetchTeamReportsCounts(), fetchTeamAnalytics(), fetchTeamBudget(), fetchBudgets()]); break;
        case "budget":           await fetchTeamBudget(); break;
        default: break;
      }
    } catch (err) { console.error("Fetch error:", err); }
    finally { setPageLoading(false); }
  }, [fetchTeamQueue, fetchTeamDashboard, fetchStats, fetchMyExpenses, fetchClaims, fetchTeamExpenses, fetchCategories, fetchTeamAnalytics, fetchTeamReportsCounts, fetchTeamBudget]);

  useEffect(() => {
    fetchCategories();
    loadPage("dashboard");
  }, [fetchCategories, loadPage]);

  useEffect(() => {
    if (modal?.type === "approve") {
      fetchBudgets();
    }
  }, [modal?.type, fetchBudgets]);

  const onNav = (page) => { setActivePage(page); setNotifOpen(false); loadPage(page); };

  const approveExpense = async (item) => {
    try {
      const h = { ...authHeader(), "Content-Type": "application/json" };
      await fetch(`${API_BASE_URL}/api/expenses/${item.id}/approve`, { method: "PATCH", headers: h });
      toast.success(`${item.id} approved successfully.`);
      await Promise.all([fetchTeamQueue(), fetchTeamDashboard()]);
    } catch { toast.error("Approval failed"); }
    closeModal();
  };

  const rejectExpense = async (item) => {
    try {
      const h = { ...authHeader(), "Content-Type": "application/json" };
      await fetch(`${API_BASE_URL}/api/expenses/${item.id}/reject`, { method: "PATCH", headers: h, body: JSON.stringify({ reason: "Rejected by manager" }) });
      toast.error(`${item.id} rejected.`);
      await Promise.all([fetchTeamQueue(), fetchTeamDashboard()]);
    } catch { toast.error("Rejection failed"); }
    closeModal();
  };

  let content = null;
  if (activePage === "dashboard") content = <DashboardPage teamDashboard={teamDashboard} teamQueue={teamQueue} myStats={myStats} onNav={onNav} onModal={openModal} onRefresh={fetchTeamDashboard} />;
  if (activePage === "my-expenses") content = <MyExpensesPage items={myExpenses} myStats={myStats} filter={myFilter} setFilter={setMyFilter} onNav={onNav} onModal={openModal} onRefresh={fetchMyExpenses} />;
  if (activePage === "my-claims") content = <ClaimsPage claims={myClaims} onModal={openModal} onNav={onNav} onRefresh={fetchClaims} />;
  if (activePage === "team-expenses") content = <TeamExpensesPage items={teamExpenses} filters={teamFilters} setFilters={setTeamFilters} categories={categories} onModal={openModal} onRefresh={fetchTeamExpenses} />;
  if (activePage === "approval-queue") content = <ApprovalQueuePage queue={teamQueue} onModal={openModal} onRefresh={fetchTeamQueue} />;
  if (activePage === "analytics") content = <AnalyticsPage teamAnalytics={teamAnalytics} onRefresh={fetchTeamAnalytics} />;
  if (activePage === "reports") content = <ReportsPage teamReportsCounts={teamReportsCounts} teamAnalytics={teamAnalytics} teamBudget={teamBudget} budgets={budgets} onRefresh={fetchTeamReportsCounts} />;
  if (activePage === "budget") content = <BudgetPage teamBudget={teamBudget} onRefresh={fetchTeamBudget} />;
  if (activePage === "settings") content = <ComingSoonPage title="Settings" />;

  return (
    <>
      <ManagerNavbar />
      <style>{STYLES}</style>
      <div className="me-root">
        <Sidebar activePage={activePage} onNav={onNav} queueCount={teamQueue.length} onModal={openModal} />
        <div className="me-main">
          <Topbar activePage={activePage} notifOpen={notifOpen} setNotifOpen={setNotifOpen} onNav={onNav} onModal={openModal} />
          <div className="me-content">
            {pageLoading
              ? <div className="me-spinner-wrap"><div className="me-spinner" /><div className="me-spinner-label">Loading...</div></div>
              : content}
          </div>
        </div>
      </div>

      {modal?.type === "submit-expense" ? (
        <SubmitExpenseModal categories={categories} onClose={closeModal} onSubmitted={() => Promise.all([fetchMyExpenses(), fetchStats()])} />
      ) : null}

      {modal?.type === "details" ? (
        <DetailModalContent item={modal.data} onApprove={(item) => openModal("approve", item)} onReject={(item) => openModal("reject", item)} onClose={closeModal} />
      ) : null}

    {modal?.type === "approve" ? (() => {
      const exp = modal.data;
      let budgetWarning = null;
      let isOverBudget = false;

      if (exp) {
        // Match budget to the expense's own month, not the current month
        const expPeriod = exp.date ? exp.date.substring(0, 7) : null;
        const specificBudget = (budgets || []).find(b =>
          b.department === exp.dept &&
          b.category === exp.category &&
          (!expPeriod || b.period === expPeriod)
        );
        const overallBudget = (budgets || []).find(b =>
          b.department === exp.dept &&
          (!b.category || b.category === "Overall") &&
          (!expPeriod || b.period === expPeriod)
        );
        const relevantBudget = specificBudget || overallBudget;

        if (relevantBudget && relevantBudget.allocatedAmount) {
          const allocated = Number(relevantBudget.allocatedAmount);
          const spent = Number(relevantBudget.spentAmount || 0);
          const amt = Number(exp.amount || 0);

          if (spent + amt > allocated) {
            isOverBudget = true;
            budgetWarning = `Warning: Approving this expense will exceed the ${relevantBudget.category || "Overall"} budget for ${relevantBudget.department} (${relevantBudget.period}). Budget: ${fmtCurrency(allocated)}, Already spent: ${fmtCurrency(spent)}, This expense: ${fmtCurrency(amt)} → Total: ${fmtCurrency(spent + amt)}`;
          }
        }
      }

      return (
        <Modal
          title={`Approve ${exp.id}`}
          onClose={closeModal}
          footer={<><button className="me-btn me-btn-success" onClick={() => approveExpense(exp)} disabled={isOverBudget} style={isOverBudget ? { opacity: 0.5, cursor: "not-allowed" } : {}}>Confirm </button><button className="me-btn" onClick={closeModal}>Cancel</button></>}
        >
          <div className="me-alert me-as-green"><Mi icon="check_circle" />Confirm approval of this expense?</div>
          {budgetWarning && (
            <div className="me-alert me-as-red" style={{ marginTop: 14 }}>
              <Mi icon="warning" style={{ fontSize: 18 }} />
              <div>
                <div style={{ fontWeight: 600, marginBottom: 2 }}>Budget Exceeded</div>
                <div>{budgetWarning}</div>
              </div>
            </div>
          )}
          <div className="me-detail-grid" style={{ marginTop: 14 }}>
            <div className="me-detail-row"><div className="me-detail-key">Employee</div><div className="me-detail-val">{exp.employee}</div></div>
            <div className="me-detail-row"><div className="me-detail-key">Amount</div><div className="me-detail-val">{fmtCurrency(exp.amount)}</div></div>
          </div>
        </Modal>
      );
    })() : null}

      {modal?.type === "reject" ? (
        <Modal
          title={`Reject ${modal.data.id}`}
          onClose={closeModal}
          footer={<><button className="me-btn" onClick={closeModal}>Cancel</button><button className="me-btn me-btn-danger" onClick={() => rejectExpense(modal.data)}>Reject Expense</button></>}
        >
          <div className="me-alert me-as-red"><Mi icon="warning" />Rejecting this expense sends it back to the employee.</div>
          <div className="me-field" style={{ marginTop: 14 }}><label className="me-label">Reason</label><textarea className="me-textarea" placeholder="Missing receipt, invalid amount, out-of-policy item..." /></div>
        </Modal>
      ) : null}

      {modal?.type === "filters" ? (
        <Modal
          title="Advanced Filters"
          onClose={closeModal}
          footer={<><button className="me-btn" onClick={closeModal}>Close</button><button className="me-btn me-btn-primary" onClick={() => { toast.success("Filters applied."); closeModal(); }}>Apply</button></>}
        >
          <div className="me-form-grid">
            <div className="me-field"><label className="me-label">From Date</label><input className="me-input" type="date" /></div>
            <div className="me-field"><label className="me-label">To Date</label><input className="me-input" type="date" /></div>
            <div className="me-field"><label className="me-label">Department</label><select className="me-select"><option>All</option><option>Backend Team</option><option>Design</option><option>Product</option></select></div>
            <div className="me-field"><label className="me-label">Approval Level</label><select className="me-select"><option>All</option><option>L1</option><option>L2</option></select></div>
          </div>
        </Modal>
      ) : null}

      {modal?.type === "claim" ? (() => {
        const c = modal.data;
        return (
          <Modal
            title={`Claim Details · ${c.id}`}
            onClose={closeModal}
            footer={
              <>
                <button className="me-btn" onClick={closeModal}>Close</button>
                {c.status === "Reimbursed" && (
                  <button className="me-btn me-btn-primary" onClick={() => downloadClaimSlip(c)}>
                    <Mi icon="download" />Download Slip
                  </button>
                )}
              </>
            }
          >
            <div className={`me-alert ${c.status === "Reimbursed" ? "me-as-green" : c.status === "Rejected" ? "me-as-red" : "me-as-blue"}`}>
              <Mi icon={c.status === "Reimbursed" ? "check_circle" : c.status === "Rejected" ? "cancel" : "folder_open"} />
              <strong>{c.status}</strong> · {c.title}
            </div>
            <div className="me-detail-grid" style={{ marginTop: 14 }}>
              <div className="me-detail-row"><div className="me-detail-key">Claim ID</div><div className="me-detail-val" style={{ color: "var(--accent)" }}>{c.id}</div></div>
              <div className="me-detail-row"><div className="me-detail-key">Status</div><div className="me-detail-val"><Pill status={c.status} /></div></div>
              <div className="me-detail-row" style={{ gridColumn: "1 / -1" }}><div className="me-detail-key">Title</div><div className="me-detail-val">{c.title}</div></div>
              <div className="me-detail-row"><div className="me-detail-key">Period</div><div className="me-detail-val">{c.period || "—"}</div></div>
              <div className="me-detail-row"><div className="me-detail-key">No. of Expenses</div><div className="me-detail-val">{c.items}</div></div>
              <div className="me-detail-row"><div className="me-detail-key">Total Amount</div><div className="me-detail-val" style={{ color: "var(--green)", fontSize: 16 }}>{fmtCurrency(c.total || 0)}</div></div>
              {c.employee && <div className="me-detail-row"><div className="me-detail-key">Employee</div><div className="me-detail-val">{c.employee}</div></div>}
            </div>
          </Modal>
        );
      })() : null}

      {modal?.type === "profile" ? (
        <Modal
          title="My Profile"
          onClose={closeModal}
          footer={<><button className="me-btn me-btn-danger me-btn-sm" onClick={() => { toast.info("Signing out..."); closeModal(); }}>Sign Out</button><button className="me-btn me-btn-primary" onClick={closeModal}>Close</button></>}
        >
          <div style={{ textAlign: "center", marginBottom: 18 }}>
            <div style={{ width: 60, height: 60, borderRadius: "50%", background: "linear-gradient(135deg,#F59E0B,#EF4444)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22, fontWeight: 700, color: "#fff", margin: "0 auto 10px" }}>RS</div>
            <div style={{ fontSize: 17, fontWeight: 700 }}>Ravi Sharma</div>
            <div className="me-card-sub">Engineering Manager · Backend Team</div>
          </div>
          {[
            ["Employee ID", "EMP-1042"],
            ["Email", "ravi.sharma@balintra.com"],
            ["Department", "Engineering · Backend"],
            ["Role", "ROLE_MANAGER"],
            ["Bank on File", "✓ HDFC ••••4821"],
          ].map(([key, value]) => (
            <div key={key} className="me-detail-row" style={{ marginBottom: 8 }}>
              <div className="me-detail-key">{key}</div>
              <div className="me-detail-val" style={key === "Bank on File" ? { color: "var(--green)" } : null}>{value}</div>
            </div>
          ))}
        </Modal>
      ) : null}

      {modal?.type === "settings" ? (
        <Modal
          title="Settings"
          onClose={closeModal}
          footer={<button className="me-btn me-btn-primary" onClick={() => { toast.success("Settings saved."); closeModal(); }}>Save Settings</button>}
        >
          {[
            ["email", "Email Notifications", "Receive email alerts for approvals"],
            ["reminders", "Approval Reminders", "Remind me of pending queue daily"],
            ["budgetAlerts", "Budget Alerts", "Alert when dept budget hits 80%"],
          ].map(([key, title, desc], idx, arr) => (
            <div key={key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 0", borderBottom: idx === arr.length - 1 ? "none" : "1px solid var(--border)" }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{title}</div>
                <div className="me-card-sub">{desc}</div>
              </div>
              <div className={`me-switch ${settings[key] ? "" : "off"}`} onClick={() => setSettings((current) => ({ ...current, [key]: !current[key] }))}>
                <div className="me-switch-dot" />
              </div>
            </div>
          ))}
        </Modal>
      ) : null}
    </>
  );
}
